var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVl3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 279.853,
    height: 225.786,
    viewBox: "0 0 279.853 225.786",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1365",
    "data-name": "Path 1365",
    d: "M215.77,85.092a49.428,49.428,0,1,1-62.614-47.645c.573-5.343,6.817-9.554,14.441-9.554,7.99,0,14.467,4.623,14.485,10.334A49.446,49.446,0,0,1,215.77,85.092Z",
    transform: "translate(-116.915 -27.893)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1395",
    "data-name": "Path 1395",
    d: "M118.693,313.241a49.425,49.425,0,1,1-81.83-37.32,7,7,0,0,1-.354-2.2c0-5.182,5.662-9.379,12.649-9.379a16.042,16.042,0,0,1,6.558,1.357,49.464,49.464,0,0,1,62.977,47.546Z",
    transform: "translate(-19.843 -263.813)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1085",
    "data-name": "Rectangle 1085",
    width: 218,
    height: 174,
    transform: "translate(3898.045 5902.74)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1923",
    "data-name": "Group 1923",
    transform: "translate(-3239.999 -1058.214)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1055",
    "data-name": "Group 1055",
    transform: "translate(3413.521 1063.539)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1050",
    "data-name": "Group 1050",
    transform: "translate(63.382)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1049",
    "data-name": "Group 1049"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_964",
    "data-name": "Path 964",
    d: "M240.6,38.256a.245.245,0,0,1-.05-.005q-.651-.148-1.308-.279a.224.224,0,0,1,.087-.44q.663.133,1.32.282a.224.224,0,0,1-.049.443Z",
    transform: "translate(-239.062 -37.527)",
    fill: "#25292b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1052",
    "data-name": "Group 1052",
    transform: "translate(0 0.941)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1051",
    "data-name": "Group 1051"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_965",
    "data-name": "Path 965",
    d: "M163.955,143.82c-.409,0-.821,0-1.23-.013a.224.224,0,0,1-.219-.229.241.241,0,0,1,.229-.219c.406.009.813.015,1.22.013q.729,0,1.453-.021a.224.224,0,0,1,.013.448Q164.691,143.82,163.955,143.82Zm-3.906-.139h-.016c-.9-.065-1.8-.152-2.683-.261a.224.224,0,1,1,.055-.445c.876.108,1.771.2,2.66.259a.224.224,0,0,1-.016.447Zm8.045-.025a.224.224,0,0,1-.017-.447c.883-.069,1.777-.162,2.658-.275a.224.224,0,1,1,.057.444c-.889.115-1.791.209-2.681.279Zm-13.371-.631a.213.213,0,0,1-.039,0c-.886-.155-1.775-.333-2.643-.531a.224.224,0,0,1,.1-.437c.86.2,1.742.374,2.62.528a.224.224,0,0,1-.039.444Zm18.693-.057a.224.224,0,0,1-.04-.444c.871-.158,1.752-.341,2.617-.544a.224.224,0,0,1,.1.436c-.873.2-1.761.389-2.639.548A.228.228,0,0,1,173.417,142.969Zm-23.926-1.135a.217.217,0,0,1-.061-.008c-.861-.243-1.728-.512-2.575-.8A.224.224,0,1,1,147,140.6c.84.284,1.7.551,2.553.792a.224.224,0,0,1-.061.44Zm29.151-.091a.224.224,0,0,1-.062-.439c.85-.245,1.707-.517,2.548-.808a.224.224,0,0,1,.146.423c-.848.293-1.712.567-2.569.814A.227.227,0,0,1,178.642,141.743Zm-34.24-1.631a.22.22,0,0,1-.082-.016c-.836-.331-1.672-.688-2.484-1.059a.224.224,0,1,1,.186-.408c.806.368,1.634.722,2.463,1.05a.224.224,0,0,1-.083.432Zm39.313-.12a.224.224,0,0,1-.084-.432c.823-.332,1.646-.689,2.447-1.06a.224.224,0,1,1,.188.406c-.808.375-1.638.735-2.468,1.07A.227.227,0,0,1,183.715,139.992Zm-44.2-2.114a.221.221,0,0,1-.1-.025c-.793-.412-1.588-.852-2.363-1.305a.224.224,0,0,1,.227-.386c.768.45,1.556.886,2.342,1.294a.224.224,0,0,1-.1.423Zm49.062-.141a.224.224,0,0,1-.1-.422c.782-.412,1.565-.852,2.329-1.3a.224.224,0,0,1,.229.385c-.77.457-1.56.9-2.349,1.315A.219.219,0,0,1,188.574,137.737Zm-53.7-2.577a.225.225,0,0,1-.123-.037c-.747-.491-1.494-1.008-2.216-1.537a.224.224,0,0,1,.264-.362c.717.525,1.457,1.037,2.2,1.524a.224.224,0,0,1-.123.411ZM193.183,135a.224.224,0,0,1-.124-.41c.737-.49,1.473-1.006,2.187-1.534a.224.224,0,0,1,.266.36c-.72.532-1.462,1.053-2.2,1.547A.22.22,0,0,1,193.183,135Zm-62.64-3.011a.221.221,0,0,1-.141-.05c-.7-.565-1.385-1.154-2.049-1.753a.224.224,0,1,1,.3-.332c.659.593,1.343,1.177,2.032,1.737a.224.224,0,0,1-.141.4Zm66.951-.18a.224.224,0,0,1-.142-.4c.686-.563,1.366-1.151,2.022-1.747a.224.224,0,0,1,.3.331c-.661.6-1.347,1.194-2.038,1.762A.225.225,0,0,1,197.494,131.809Zm-70.942-3.41a.223.223,0,0,1-.158-.065c-.634-.631-1.261-1.287-1.862-1.949a.224.224,0,1,1,.331-.3c.6.656,1.218,1.306,1.846,1.932a.224.224,0,0,1-.158.383Zm74.911-.2a.224.224,0,0,1-.159-.382c.627-.631,1.245-1.284,1.836-1.943a.224.224,0,1,1,.333.3c-.6.664-1.22,1.323-1.852,1.959A.224.224,0,0,1,201.463,128.2Zm-78.519-3.773a.223.223,0,0,1-.173-.082c-.566-.691-1.123-1.405-1.656-2.125a.224.224,0,0,1,.361-.266c.528.714,1.08,1.423,1.641,2.108a.224.224,0,0,1-.031.315A.22.22,0,0,1,122.945,124.427Zm82.106-.22a.224.224,0,0,1-.173-.366c.558-.688,1.107-1.4,1.632-2.119a.224.224,0,1,1,.362.264c-.529.724-1.083,1.443-1.646,2.137A.224.224,0,0,1,205.051,124.207Zm-85.294-4.093a.225.225,0,0,1-.187-.1c-.5-.747-.978-1.514-1.432-2.281a.224.224,0,0,1,.385-.229c.45.76.928,1.521,1.42,2.261a.224.224,0,0,1-.186.348Zm88.463-.243a.224.224,0,0,1-.187-.347c.487-.742.961-1.507,1.41-2.274a.224.224,0,1,1,.386.226c-.452.773-.931,1.545-1.422,2.293A.224.224,0,0,1,208.22,119.871Zm-91.2-4.367a.223.223,0,0,1-.2-.12c-.417-.791-.818-1.6-1.193-2.412a.224.224,0,1,1,.407-.188c.371.8.77,1.607,1.182,2.391a.224.224,0,0,1-.2.328Zm93.913-.27a.227.227,0,0,1-.1-.025.225.225,0,0,1-.1-.3c.41-.79.805-1.6,1.173-2.406a.224.224,0,0,1,.408.186c-.371.814-.769,1.63-1.183,2.427A.223.223,0,0,1,210.935,115.234Zm-96.165-4.59a.224.224,0,0,1-.207-.141c-.335-.832-.652-1.681-.943-2.525a.224.224,0,1,1,.423-.146c.288.836.6,1.678.935,2.5a.223.223,0,0,1-.124.291A.22.22,0,0,1,114.77,110.644Zm98.4-.3a.221.221,0,0,1-.082-.016.224.224,0,0,1-.126-.29c.327-.826.637-1.672.922-2.515a.224.224,0,1,1,.424.143c-.287.85-.6,1.7-.93,2.536A.223.223,0,0,1,213.166,110.343ZM113.021,105.57a.223.223,0,0,1-.215-.162c-.248-.86-.478-1.738-.681-2.609a.224.224,0,0,1,.436-.1c.2.863.429,1.733.675,2.586a.224.224,0,0,1-.215.286Zm101.864-.317a.217.217,0,0,1-.061-.008.224.224,0,0,1-.155-.277c.241-.853.462-1.724.659-2.59a.221.221,0,0,1,.268-.168.224.224,0,0,1,.169.268c-.2.873-.422,1.752-.664,2.612A.225.225,0,0,1,214.885,105.253ZM111.8,100.344a.224.224,0,0,1-.22-.184c-.159-.877-.3-1.774-.412-2.664a.224.224,0,0,1,.194-.25.222.222,0,0,1,.251.193c.114.883.251,1.771.408,2.642a.223.223,0,0,1-.22.264Zm104.276-.324a.267.267,0,0,1-.039,0,.224.224,0,0,1-.182-.259c.153-.875.285-1.764.392-2.645a.228.228,0,0,1,.249-.2.224.224,0,0,1,.2.25c-.109.887-.242,1.785-.4,2.666A.225.225,0,0,1,216.075,100.02Zm-104.961-5a.224.224,0,0,1-.223-.207c-.069-.89-.117-1.8-.141-2.692a.224.224,0,0,1,.218-.23.232.232,0,0,1,.23.218c.025.889.072,1.787.14,2.669a.224.224,0,0,1-.206.241Zm105.613-.329h-.016a.224.224,0,0,1-.207-.24c.063-.883.1-1.781.123-2.67a.22.22,0,0,1,.229-.219.223.223,0,0,1,.219.228c-.019.9-.061,1.8-.124,2.692A.224.224,0,0,1,216.727,94.693Zm-105.76-5.037h-.005a.224.224,0,0,1-.218-.229c.02-.9.063-1.8.127-2.692a.224.224,0,1,1,.447.032c-.064.88-.107,1.779-.127,2.67A.224.224,0,0,1,110.967,89.657Zm105.875-.329a.224.224,0,0,1-.224-.218c-.025-.885-.074-1.783-.143-2.669a.224.224,0,0,1,.447-.036c.071.894.119,1.8.144,2.692a.224.224,0,0,1-.217.23ZM111.356,84.3l-.028,0a.224.224,0,0,1-.2-.249c.11-.889.244-1.786.4-2.666a.224.224,0,1,1,.441.078c-.153.872-.286,1.762-.4,2.644A.224.224,0,0,1,111.356,84.3Zm105.063-.326a.223.223,0,0,1-.221-.2c-.114-.879-.253-1.768-.411-2.641a.224.224,0,1,1,.441-.081c.16.881.3,1.777.415,2.664a.224.224,0,0,1-.193.251Zm-104.135-4.96a.215.215,0,0,1-.05-.006.223.223,0,0,1-.168-.268c.2-.874.424-1.753.667-2.612a.224.224,0,1,1,.431.122c-.241.852-.464,1.723-.661,2.59A.224.224,0,0,1,112.284,79.018ZM215.459,78.7a.224.224,0,0,1-.218-.172c-.2-.864-.432-1.734-.678-2.586a.224.224,0,1,1,.43-.124c.249.859.479,1.736.684,2.608a.223.223,0,0,1-.166.269A.231.231,0,0,1,215.459,78.7ZM113.746,73.85a.214.214,0,0,1-.072-.012.223.223,0,0,1-.14-.284c.287-.847.6-1.7.932-2.534a.224.224,0,1,1,.416.165c-.328.827-.64,1.673-.924,2.512A.224.224,0,0,1,113.746,73.85Zm100.22-.3a.224.224,0,0,1-.212-.151c-.288-.836-.6-1.676-.936-2.5a.224.224,0,1,1,.415-.168c.335.83.653,1.678.944,2.521a.225.225,0,0,1-.139.285A.237.237,0,0,1,213.966,73.547ZM115.73,68.855a.225.225,0,0,1-.2-.318c.372-.814.771-1.63,1.185-2.424a.224.224,0,1,1,.4.207c-.41.788-.806,1.6-1.175,2.4A.224.224,0,0,1,115.73,68.855Zm96.229-.277a.224.224,0,0,1-.2-.129c-.373-.8-.773-1.609-1.186-2.392a.224.224,0,0,1,.4-.209c.417.79.819,1.6,1.2,2.413a.224.224,0,0,1-.109.3A.218.218,0,0,1,211.959,68.578ZM118.211,64.09a.224.224,0,0,1-.193-.337c.454-.774.933-1.545,1.424-2.291a.224.224,0,0,1,.374.246c-.487.74-.962,1.5-1.412,2.272A.224.224,0,0,1,118.211,64.09Zm91.244-.253a.223.223,0,0,1-.193-.11c-.453-.762-.932-1.523-1.423-2.261a.224.224,0,0,1,.373-.248c.5.744.978,1.511,1.435,2.28a.224.224,0,0,1-.192.339ZM121.162,59.6a.224.224,0,0,1-.18-.357c.53-.723,1.084-1.442,1.648-2.134a.224.224,0,1,1,.348.283c-.559.687-1.109,1.4-1.634,2.117A.225.225,0,0,1,121.162,59.6Zm85.322-.232a.224.224,0,0,1-.18-.09c-.527-.711-1.08-1.419-1.645-2.106a.224.224,0,1,1,.346-.285c.57.693,1.128,1.408,1.659,2.124a.224.224,0,0,1-.179.357ZM124.55,55.437a.224.224,0,0,1-.166-.374c.6-.666,1.224-1.325,1.854-1.957a.224.224,0,1,1,.317.316c-.625.627-1.243,1.28-1.838,1.941A.224.224,0,0,1,124.55,55.437Zm78.526-.211a.225.225,0,0,1-.166-.073c-.6-.657-1.22-1.306-1.848-1.931a.224.224,0,1,1,.315-.318c.634.629,1.262,1.285,1.865,1.947a.224.224,0,0,1-.165.375Zm-74.738-3.591a.224.224,0,0,1-.151-.39c.662-.6,1.348-1.192,2.041-1.76a.224.224,0,1,1,.284.346c-.687.563-1.368,1.15-2.024,1.746A.225.225,0,0,1,128.338,51.635Zm70.928-.191a.222.222,0,0,1-.149-.058c-.66-.592-1.345-1.177-2.035-1.735a.224.224,0,1,1,.282-.348c.695.564,1.385,1.152,2.051,1.75a.224.224,0,0,1-.15.391Zm-66.778-3.21a.224.224,0,0,1-.133-.4c.719-.531,1.462-1.051,2.208-1.545a.224.224,0,0,1,.247.373c-.74.49-1.476,1.006-2.189,1.532A.222.222,0,0,1,132.489,48.234Zm62.606-.171a.221.221,0,0,1-.131-.043c-.718-.524-1.458-1.035-2.2-1.521a.224.224,0,1,1,.245-.375c.748.49,1.494,1.006,2.218,1.534a.224.224,0,0,1-.132.405ZM136.96,45.27a.224.224,0,0,1-.114-.416c.772-.457,1.563-.9,2.351-1.313a.224.224,0,0,1,.208.4c-.782.41-1.566.849-2.331,1.3A.223.223,0,0,1,136.96,45.27Zm53.643-.149a.224.224,0,0,1-.113-.031c-.766-.448-1.554-.882-2.343-1.292a.224.224,0,1,1,.206-.4c.8.412,1.591.851,2.363,1.3a.224.224,0,0,1-.113.417Zm-48.9-2.346a.224.224,0,0,1-.094-.427c.812-.375,1.643-.734,2.471-1.067a.224.224,0,1,1,.167.416c-.821.33-1.646.686-2.45,1.058A.221.221,0,0,1,141.706,42.775Zm44.127-.127a.224.224,0,0,1-.093-.02c-.808-.368-1.636-.721-2.463-1.047a.224.224,0,0,1,.164-.417c.833.329,1.67.685,2.484,1.056a.224.224,0,0,1-.093.428Zm-39.156-1.872a.224.224,0,0,1-.073-.436c.847-.291,1.71-.564,2.567-.81a.224.224,0,1,1,.124.43c-.849.244-1.705.514-2.545.8A.218.218,0,0,1,146.678,40.777Zm34.157-.1a.214.214,0,0,1-.072-.012c-.843-.284-1.7-.55-2.558-.79a.224.224,0,1,1,.121-.431c.861.242,1.73.51,2.58.8a.224.224,0,0,1-.072.436Z",
    transform: "translate(-110.743 -39.432)",
    fill: "#25292b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1054",
    "data-name": "Group 1054",
    transform: "translate(40.956 0.046)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1053",
    "data-name": "Group 1053"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_966",
    "data-name": "Path 966",
    d: "M193.883,38.356a.224.224,0,0,1-.05-.443q.656-.151,1.319-.287a.224.224,0,1,1,.089.439q-.656.134-1.307.285A.219.219,0,0,1,193.883,38.356Z",
    transform: "translate(-193.659 -37.621)",
    fill: "#25292b"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1062",
    "data-name": "Group 1062",
    transform: "translate(3239.999 1100.731)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1057",
    "data-name": "Group 1057",
    transform: "translate(63.385 1.03)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1056",
    "data-name": "Group 1056"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_967",
    "data-name": "Path 967",
    d: "M142.129,259.025a.209.209,0,0,1-.049-.005q-.652-.147-1.309-.28a.224.224,0,1,1,.088-.439q.662.133,1.319.281a.224.224,0,0,1-.049.443Z",
    transform: "translate(-140.59 -258.297)",
    fill: "#25292b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1059",
    "data-name": "Group 1059"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1058",
    "data-name": "Group 1058"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_968",
    "data-name": "Path 968",
    d: "M65.433,362.571q-.537,0-1.073-.01a.224.224,0,0,1,0-.448h0c.89.018,1.786.013,2.672-.013a.213.213,0,0,1,.231.217.224.224,0,0,1-.217.231Q66.246,362.571,65.433,362.571Zm-3.747-.131h-.016c-.9-.062-1.8-.148-2.681-.255a.224.224,0,1,1,.054-.445c.876.106,1.77.191,2.659.253a.224.224,0,0,1-.015.447Zm8.039-.041a.224.224,0,0,1-.018-.447c.885-.071,1.779-.165,2.656-.28a.224.224,0,1,1,.059.444c-.885.117-1.787.211-2.679.283Zm-13.364-.6a.247.247,0,0,1-.038,0c-.882-.153-1.771-.329-2.642-.526a.224.224,0,1,1,.1-.437c.864.195,1.745.37,2.62.521a.224.224,0,0,1-.038.445Zm18.68-.1a.224.224,0,0,1-.04-.444c.87-.159,1.75-.343,2.614-.548a.224.224,0,1,1,.1.436c-.872.206-1.759.392-2.637.553Zm-23.911-1.084a.217.217,0,0,1-.061-.008c-.864-.242-1.73-.508-2.574-.792a.224.224,0,1,1,.143-.424c.837.281,1.7.545,2.553.785a.224.224,0,0,1-.06.44Zm29.13-.15a.224.224,0,0,1-.062-.439c.849-.247,1.705-.52,2.544-.812a.224.224,0,0,1,.147.424c-.846.293-1.71.569-2.566.818A.249.249,0,0,1,80.261,360.467Zm-34.22-1.559a.229.229,0,0,1-.082-.015c-.831-.327-1.668-.682-2.485-1.053a.224.224,0,1,1,.185-.408c.811.368,1.639.719,2.464,1.044a.224.224,0,0,1-.082.432Zm39.286-.2a.224.224,0,0,1-.084-.431c.821-.333,1.643-.692,2.444-1.064a.224.224,0,1,1,.189.406c-.807.376-1.636.737-2.464,1.073A.229.229,0,0,1,85.327,358.708Zm-44.178-2.02a.219.219,0,0,1-.1-.025c-.8-.412-1.594-.85-2.364-1.3a.224.224,0,1,1,.226-.387c.764.445,1.552.879,2.344,1.288a.224.224,0,0,1-.1.423Zm49.03-.242a.224.224,0,0,1-.105-.422c.781-.413,1.563-.853,2.325-1.307a.224.224,0,0,1,.23.385c-.769.458-1.558.9-2.345,1.318A.22.22,0,0,1,90.179,356.446ZM36.51,353.983a.221.221,0,0,1-.122-.036c-.751-.49-1.5-1.006-2.219-1.531a.224.224,0,1,1,.264-.362c.716.521,1.456,1.032,2.2,1.518a.224.224,0,0,1-.123.411Zm58.269-.28a.224.224,0,0,1-.124-.41c.736-.491,1.47-1.008,2.182-1.537a.224.224,0,1,1,.267.36c-.718.532-1.458,1.054-2.2,1.549A.22.22,0,0,1,94.78,353.7Zm-62.608-2.878a.22.22,0,0,1-.141-.05c-.7-.562-1.386-1.149-2.052-1.746a.224.224,0,0,1,.3-.334c.661.592,1.345,1.174,2.035,1.731a.224.224,0,0,1-.141.4Zm66.911-.317a.224.224,0,0,1-.143-.4c.686-.566,1.365-1.154,2.017-1.75a.224.224,0,1,1,.3.33c-.657.6-1.342,1.194-2.034,1.764A.223.223,0,0,1,99.083,350.508Zm-70.908-3.26a.222.222,0,0,1-.158-.065c-.638-.632-1.266-1.286-1.866-1.943a.224.224,0,0,1,.331-.3c.594.651,1.217,1.3,1.85,1.926a.224.224,0,0,1-.158.383Zm74.869-.353a.224.224,0,0,1-.159-.382c.622-.627,1.238-1.281,1.832-1.944a.224.224,0,0,1,.334.3c-.6.668-1.221,1.328-1.848,1.96A.223.223,0,0,1,103.044,346.894Zm-78.485-3.607a.222.222,0,0,1-.173-.081c-.571-.691-1.129-1.4-1.66-2.12a.224.224,0,1,1,.359-.267c.527.709,1.081,1.416,1.646,2.1a.223.223,0,0,1-.172.366Zm82.064-.388a.224.224,0,0,1-.174-.365c.559-.691,1.106-1.4,1.628-2.12a.224.224,0,1,1,.362.263c-.526.723-1.079,1.442-1.642,2.138A.224.224,0,0,1,106.623,342.9Zm-85.262-3.913a.222.222,0,0,1-.186-.1c-.5-.742-.979-1.508-1.437-2.275a.224.224,0,1,1,.384-.229c.454.761.934,1.519,1.425,2.255a.224.224,0,0,1-.062.311A.221.221,0,0,1,21.362,338.986Zm88.422-.424a.224.224,0,0,1-.187-.346c.486-.743.959-1.509,1.406-2.275a.224.224,0,1,1,.387.226c-.45.773-.928,1.544-1.418,2.294A.225.225,0,0,1,109.784,338.562Zm-91.168-4.175a.224.224,0,0,1-.2-.119c-.418-.788-.821-1.6-1.2-2.407a.224.224,0,1,1,.406-.189c.374.8.774,1.6,1.188,2.386a.224.224,0,0,1-.2.329Zm93.875-.462a.221.221,0,0,1-.1-.025.223.223,0,0,1-.1-.3c.408-.79.8-1.6,1.169-2.406a.224.224,0,1,1,.408.185c-.37.814-.767,1.63-1.179,2.427A.223.223,0,0,1,112.491,333.925Zm-96.139-4.389a.223.223,0,0,1-.207-.139c-.336-.828-.656-1.676-.95-2.521a.224.224,0,1,1,.423-.147c.291.838.609,1.679.942,2.5a.224.224,0,0,1-.123.292A.231.231,0,0,1,16.352,329.536Zm98.363-.5a.217.217,0,0,1-.082-.016.224.224,0,0,1-.126-.29c.327-.829.636-1.676.918-2.515a.224.224,0,0,1,.424.143c-.285.846-.6,1.7-.926,2.536A.224.224,0,0,1,114.715,329.035ZM14.589,324.471a.224.224,0,0,1-.215-.161c-.251-.86-.483-1.737-.689-2.6a.224.224,0,0,1,.436-.1c.2.86.434,1.729.682,2.582a.224.224,0,0,1-.152.278A.251.251,0,0,1,14.589,324.471Zm101.837-.525a.215.215,0,0,1-.061-.008.224.224,0,0,1-.155-.276c.239-.852.46-1.723.656-2.59a.224.224,0,0,1,.437.1c-.2.875-.42,1.754-.661,2.611A.224.224,0,0,1,116.426,323.946ZM13.352,319.253a.224.224,0,0,1-.22-.183c-.161-.877-.3-1.772-.42-2.661a.224.224,0,0,1,.193-.251.222.222,0,0,1,.251.193c.116.881.256,1.769.416,2.639a.224.224,0,0,1-.18.261A.228.228,0,0,1,13.352,319.253Zm104.257-.538a.2.2,0,0,1-.039,0,.223.223,0,0,1-.182-.258c.151-.87.282-1.759.389-2.643a.224.224,0,0,1,.445.054c-.109.891-.241,1.788-.393,2.665A.224.224,0,0,1,117.609,318.715ZM12.651,313.936a.224.224,0,0,1-.223-.206c-.072-.888-.122-1.792-.149-2.689a.224.224,0,0,1,.217-.231.241.241,0,0,1,.231.217c.027.889.077,1.787.148,2.667a.224.224,0,0,1-.2.241Zm105.6-.544h-.016a.224.224,0,0,1-.207-.24c.062-.879.1-1.777.121-2.668a.207.207,0,0,1,.228-.219.223.223,0,0,1,.219.228c-.018.9-.059,1.8-.122,2.691A.224.224,0,0,1,118.256,313.392ZM12.488,308.576h0a.224.224,0,0,1-.219-.228c.017-.9.057-1.8.12-2.69a.225.225,0,0,1,.239-.208.223.223,0,0,1,.208.239c-.061.883-.1,1.781-.119,2.668A.224.224,0,0,1,12.488,308.576Zm105.877-.547a.224.224,0,0,1-.224-.217c-.026-.89-.075-1.787-.145-2.667a.224.224,0,0,1,.205-.241.227.227,0,0,1,.241.205c.071.888.12,1.793.146,2.689a.223.223,0,0,1-.217.231Zm-105.5-4.8h-.027a.225.225,0,0,1-.2-.249c.107-.887.238-1.784.39-2.666a.224.224,0,1,1,.442.077c-.151.875-.281,1.764-.386,2.643A.224.224,0,0,1,12.86,303.226Zm105.078-.542a.224.224,0,0,1-.222-.2c-.115-.879-.254-1.767-.413-2.638a.224.224,0,1,1,.441-.081c.161.879.3,1.774.417,2.661a.224.224,0,0,1-.193.251ZM13.769,297.941a.241.241,0,0,1-.049,0,.224.224,0,0,1-.169-.268c.2-.872.417-1.751.658-2.612a.222.222,0,0,1,.276-.156.225.225,0,0,1,.156.276c-.239.853-.458,1.725-.653,2.59A.224.224,0,0,1,13.769,297.941Zm103.2-.533a.224.224,0,0,1-.218-.172c-.2-.863-.432-1.732-.68-2.584a.224.224,0,0,1,.43-.125c.249.859.48,1.736.686,2.606a.224.224,0,0,1-.166.27A.267.267,0,0,1,116.973,297.409ZM15.211,292.776a.209.209,0,0,1-.071-.011.224.224,0,0,1-.141-.284c.285-.849.6-1.7.923-2.537a.224.224,0,0,1,.417.164c-.326.828-.633,1.674-.915,2.516A.224.224,0,0,1,15.211,292.776Zm100.267-.514a.224.224,0,0,1-.211-.15c-.289-.835-.605-1.675-.938-2.5a.224.224,0,0,1,.415-.168c.335.829.653,1.676.945,2.518a.223.223,0,0,1-.211.3Zm-98.3-4.487a.217.217,0,0,1-.092-.02.224.224,0,0,1-.112-.3c.368-.812.764-1.629,1.176-2.428a.224.224,0,1,1,.4.205c-.409.793-.8,1.6-1.166,2.408A.224.224,0,0,1,17.177,287.775Zm96.292-.477a.225.225,0,0,1-.2-.129c-.375-.806-.774-1.61-1.187-2.39a.224.224,0,0,1,.4-.209c.416.787.819,1.6,1.2,2.41a.225.225,0,0,1-.109.3A.229.229,0,0,1,113.469,287.3ZM19.641,283a.222.222,0,0,1-.113-.03.224.224,0,0,1-.081-.306c.451-.775.928-1.547,1.416-2.3a.224.224,0,0,1,.375.245c-.484.741-.957,1.507-1.4,2.276A.224.224,0,0,1,19.641,283Zm91.324-.441a.224.224,0,0,1-.193-.109c-.452-.761-.932-1.52-1.424-2.259a.224.224,0,0,1,.373-.248c.5.744.979,1.51,1.435,2.277a.224.224,0,0,1-.192.339Zm-88.391-4.054a.229.229,0,0,1-.132-.042.225.225,0,0,1-.049-.313c.528-.725,1.079-1.445,1.639-2.14a.224.224,0,0,1,.349.282c-.556.689-1.1,1.4-1.626,2.121A.224.224,0,0,1,22.574,278.508Zm85.419-.408a.225.225,0,0,1-.18-.09c-.529-.714-1.082-1.422-1.644-2.1a.224.224,0,1,1,.346-.284c.567.688,1.124,1.4,1.658,2.122a.223.223,0,0,1-.18.357Zm-82.048-3.768a.224.224,0,0,1-.167-.373c.6-.666,1.217-1.327,1.846-1.962a.224.224,0,1,1,.318.315c-.623.631-1.239,1.286-1.83,1.947A.224.224,0,0,1,25.945,274.332Zm78.64-.372a.224.224,0,0,1-.165-.073c-.6-.657-1.221-1.305-1.848-1.928a.224.224,0,0,1,.316-.319c.633.629,1.26,1.283,1.864,1.945a.224.224,0,0,1-.165.375Zm-74.869-3.441a.224.224,0,0,1-.151-.389c.657-.6,1.341-1.195,2.032-1.766a.224.224,0,1,1,.285.345c-.686.567-1.364,1.156-2.015,1.752A.226.226,0,0,1,29.716,270.519Zm71.061-.336a.224.224,0,0,1-.15-.057c-.658-.591-1.343-1.174-2.034-1.734a.224.224,0,0,1,.282-.348c.7.565,1.387,1.153,2.05,1.748a.224.224,0,0,1-.149.391Zm-66.927-3.076a.224.224,0,0,1-.134-.4c.713-.531,1.453-1.053,2.2-1.552a.224.224,0,1,1,.249.372c-.74.495-1.474,1.013-2.181,1.539A.225.225,0,0,1,33.851,267.106Zm62.757-.3a.224.224,0,0,1-.132-.043c-.713-.521-1.453-1.032-2.2-1.52a.224.224,0,1,1,.245-.374c.751.491,1.5,1.008,2.217,1.533a.224.224,0,0,1-.132.4Zm-58.3-2.678a.224.224,0,0,1-.115-.416c.77-.46,1.559-.9,2.343-1.321a.224.224,0,1,1,.21.4c-.778.412-1.559.853-2.323,1.31A.225.225,0,0,1,38.3,264.128Zm53.812-.261a.222.222,0,0,1-.113-.03c-.767-.449-1.554-.883-2.341-1.291a.224.224,0,1,1,.206-.4c.793.411,1.588.849,2.362,1.3a.224.224,0,0,1-.114.417Zm-49.083-2.249a.224.224,0,0,1-.095-.427c.808-.378,1.636-.74,2.463-1.076a.224.224,0,1,1,.169.415c-.82.334-1.641.693-2.443,1.067A.224.224,0,0,1,43.034,261.617Zm44.317-.221a.23.23,0,0,1-.093-.02c-.808-.368-1.635-.72-2.461-1.046a.224.224,0,0,1,.164-.417c.833.329,1.668.684,2.483,1.055a.224.224,0,0,1-.093.428ZM48,259.6a.223.223,0,0,1-.074-.435c.849-.3,1.712-.572,2.565-.822a.224.224,0,0,1,.125.431c-.846.246-1.7.52-2.543.814A.215.215,0,0,1,48,259.6Zm34.359-.175a.226.226,0,0,1-.072-.011c-.838-.283-1.7-.549-2.556-.79a.224.224,0,1,1,.121-.431c.866.244,1.733.511,2.578.8a.224.224,0,0,1-.072.436Zm-29.212-1.329a.224.224,0,0,1-.052-.442c.872-.207,1.759-.394,2.636-.556a.224.224,0,0,1,.081.441c-.87.16-1.749.345-2.613.551A.236.236,0,0,1,53.144,258.094Zm5.273-.973a.224.224,0,0,1-.029-.446c.885-.117,1.786-.213,2.678-.286a.224.224,0,1,1,.036.447c-.885.072-1.778.167-2.655.283Zm13.38-.082h-.027c-.876-.105-1.771-.19-2.66-.251a.224.224,0,0,1,.031-.447c.9.062,1.8.147,2.683.252a.224.224,0,0,1-.027.447Zm-8.035-.353a.224.224,0,0,1-.007-.448c.557-.017,1.116-.029,1.677-.026q.509,0,1.017.009a.224.224,0,0,1,.22.228.21.21,0,0,1-.228.22c-.35-.006-.706-.008-1.053-.01q-.812,0-1.619.026Z",
    transform: "translate(-12.264 -256.213)",
    fill: "#25292b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1061",
    "data-name": "Group 1061",
    transform: "translate(62.065 0.782)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1060",
    "data-name": "Group 1060"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_969",
    "data-name": "Path 969",
    d: "M139.461,258.492a.223.223,0,0,1-.044,0q-.655-.13-1.315-.245a.224.224,0,1,1,.077-.441q.665.115,1.326.247a.224.224,0,0,1-.043.443Z",
    transform: "translate(-137.916 -257.797)",
    fill: "#25292b"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1150",
    "data-name": "Group 1150",
    transform: "translate(3304.609 1101.952)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1098",
    "data-name": "Group 1098",
    transform: "translate(93.05 37.903)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1088",
    "data-name": "Group 1088",
    transform: "translate(5.099 3.334)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1087",
    "data-name": "Group 1087"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1086",
    "data-name": "Group 1086"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_980",
    "data-name": "Path 980",
    d: "M397.291,230.832h0a.211.211,0,0,1-.182-.106l-1.99-3.444a.211.211,0,0,1,0-.211l1.99-3.443a.211.211,0,0,1,.182-.105h0a.211.211,0,0,1,.183.105l1.994,3.443a.21.21,0,0,1,0,.211l-1.994,3.444A.211.211,0,0,1,397.291,230.832Zm-1.746-3.655,1.746,3.022,1.75-3.022-1.75-3.022Z",
    transform: "translate(-395.091 -223.523)",
    fill: "#25292b"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1091",
    "data-name": "Group 1091",
    transform: "translate(0.566 4.115)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1090",
    "data-name": "Group 1090"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1089",
    "data-name": "Group 1089"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_981",
    "data-name": "Path 981",
    d: "M387.115,227.506a1.2,1.2,0,1,1,1.2-1.2A1.2,1.2,0,0,1,387.115,227.506Zm0-1.981a.779.779,0,1,0,.779.779A.781.781,0,0,0,387.115,225.525Z",
    transform: "translate(-385.914 -225.103)",
    fill: "#25292b"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1094",
    "data-name": "Group 1094",
    transform: "translate(4.26)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1093",
    "data-name": "Group 1093"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1092",
    "data-name": "Group 1092"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_982",
    "data-name": "Path 982",
    d: "M394.443,218.871a1.049,1.049,0,1,1,1.049-1.049A1.051,1.051,0,0,1,394.443,218.871Zm0-1.676a.628.628,0,1,0,.628.627A.628.628,0,0,0,394.443,217.195Z",
    transform: "translate(-393.393 -216.773)",
    fill: "#25292b"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1097",
    "data-name": "Group 1097",
    transform: "translate(0 1.027)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1096",
    "data-name": "Group 1096"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1095",
    "data-name": "Group 1095"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_983",
    "data-name": "Path 983",
    d: "M385.544,220.407a.777.777,0,1,1,.777-.776A.777.777,0,0,1,385.544,220.407Zm0-1.132a.355.355,0,1,0,.355.356A.356.356,0,0,0,385.544,219.275Z",
    transform: "translate(-384.768 -218.853)",
    fill: "#25292b"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1111",
    "data-name": "Group 1111",
    transform: "translate(68.484)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1101",
    "data-name": "Group 1101",
    transform: "translate(3.07 3.9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1100",
    "data-name": "Group 1100"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1099",
    "data-name": "Group 1099"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_984",
    "data-name": "Path 984",
    d: "M342.981,153.625h0a.211.211,0,0,1-.183-.106l-1.522-2.635a.212.212,0,0,1,0-.211l1.522-2.635a.21.21,0,0,1,.183-.105h0a.21.21,0,0,1,.182.105l1.526,2.635a.213.213,0,0,1,0,.211l-1.526,2.635A.211.211,0,0,1,342.981,153.625ZM341.7,150.78l1.279,2.213,1.281-2.213-1.281-2.214Z",
    transform: "translate(-341.248 -147.934)",
    fill: "#25292b"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1104",
    "data-name": "Group 1104",
    transform: "translate(0 3.233)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1103",
    "data-name": "Group 1103"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1102",
    "data-name": "Group 1102"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_985",
    "data-name": "Path 985",
    d: "M336.234,148.987a1.2,1.2,0,1,1,1.2-1.2A1.2,1.2,0,0,1,336.234,148.987Zm0-1.981a.779.779,0,1,0,.779.779A.78.78,0,0,0,336.234,147.006Z",
    transform: "translate(-335.033 -146.584)",
    fill: "#25292b"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1107",
    "data-name": "Group 1107",
    transform: "translate(3.695 0.566)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1106",
    "data-name": "Group 1106"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1105",
    "data-name": "Group 1105"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_986",
    "data-name": "Path 986",
    d: "M343.562,143.283a1.049,1.049,0,1,1,1.05-1.05A1.051,1.051,0,0,1,343.562,143.283Zm0-1.677a.628.628,0,1,0,.628.627A.628.628,0,0,0,343.562,141.606Z",
    transform: "translate(-342.513 -141.184)",
    fill: "#25292b"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1110",
    "data-name": "Group 1110",
    transform: "translate(0.425)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1109",
    "data-name": "Group 1109"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1108",
    "data-name": "Group 1108"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_987",
    "data-name": "Path 987",
    d: "M336.669,141.591a.777.777,0,1,1,.777-.776A.777.777,0,0,1,336.669,141.591Zm0-1.132a.355.355,0,1,0,.355.356A.356.356,0,0,0,336.669,140.459Z",
    transform: "translate(-335.893 -140.038)",
    fill: "#25292b"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1130",
    "data-name": "Group 1130",
    transform: "translate(0 58.697)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1114",
    "data-name": "Group 1114",
    transform: "translate(7.232 6.127)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1113",
    "data-name": "Group 1113"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1112",
    "data-name": "Group 1112"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_988",
    "data-name": "Path 988",
    d: "M213.225,278.585h0a.212.212,0,0,1-.183-.106l-1.989-3.443a.212.212,0,0,1,0-.211l1.989-3.443a.212.212,0,0,1,.183-.106h0a.212.212,0,0,1,.183.105l1.994,3.443a.21.21,0,0,1,0,.211l-1.994,3.444A.212.212,0,0,1,213.225,278.585Zm-1.746-3.655,1.746,3.022,1.75-3.022-1.75-3.022Z",
    transform: "translate(-211.025 -271.276)",
    fill: "#25292b"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1117",
    "data-name": "Group 1117",
    transform: "translate(0 4.926)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1116",
    "data-name": "Group 1116"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1115",
    "data-name": "Group 1115"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_989",
    "data-name": "Path 989",
    d: "M197.585,271.247a1.2,1.2,0,1,1,1.2-1.2A1.2,1.2,0,0,1,197.585,271.247Zm0-1.981a.779.779,0,1,0,.779.78A.781.781,0,0,0,197.585,269.266Z",
    transform: "translate(-196.384 -268.844)",
    fill: "#25292b"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1120",
    "data-name": "Group 1120",
    transform: "translate(6.502 2.793)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1119",
    "data-name": "Group 1119"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1118",
    "data-name": "Group 1118"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_990",
    "data-name": "Path 990",
    d: "M210.6,266.625a1.049,1.049,0,1,1,1.05-1.049A1.051,1.051,0,0,1,210.6,266.625Zm0-1.677a.628.628,0,1,0,.628.628A.628.628,0,0,0,210.6,264.948Z",
    transform: "translate(-209.547 -264.526)",
    fill: "#25292b"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1123",
    "data-name": "Group 1123",
    transform: "translate(12.757 7.294)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1122",
    "data-name": "Group 1122"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1121",
    "data-name": "Group 1121"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_991",
    "data-name": "Path 991",
    d: "M222.988,275.193a.777.777,0,1,1,.777-.777A.778.778,0,0,1,222.988,275.193Zm0-1.132a.355.355,0,1,0,.356.355A.355.355,0,0,0,222.988,274.061Z",
    transform: "translate(-222.212 -273.639)",
    fill: "#25292b"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1126",
    "data-name": "Group 1126",
    transform: "translate(12.313 0.144)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1125",
    "data-name": "Group 1125"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1124",
    "data-name": "Group 1124"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_992",
    "data-name": "Path 992",
    d: "M222.772,263.911h0a.211.211,0,0,1-.183-.106l-1.249-2.162a.209.209,0,0,1,0-.211l1.249-2.162a.211.211,0,0,1,.183-.106h0a.21.21,0,0,1,.182.105l1.252,2.163a.21.21,0,0,1,0,.211l-1.252,2.163A.21.21,0,0,1,222.772,263.911Zm-1.006-2.373,1.006,1.741,1.009-1.741-1.009-1.742Z",
    transform: "translate(-221.311 -259.164)",
    fill: "#25292b"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1129",
    "data-name": "Group 1129",
    transform: "translate(3.735)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1128",
    "data-name": "Group 1128"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1127",
    "data-name": "Group 1127"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_993",
    "data-name": "Path 993",
    d: "M204.722,260.425a.777.777,0,1,1,.777-.777A.777.777,0,0,1,204.722,260.425Zm0-1.132a.355.355,0,1,0,.356.355A.355.355,0,0,0,204.722,259.294Z",
    transform: "translate(-203.946 -258.872)",
    fill: "#25292b"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1149",
    "data-name": "Group 1149",
    transform: "translate(147.155 25.279)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1133",
    "data-name": "Group 1133",
    transform: "translate(7.232 6.127)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1132",
    "data-name": "Group 1132"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1131",
    "data-name": "Group 1131"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_994",
    "data-name": "Path 994",
    d: "M511.145,210.929h0a.212.212,0,0,1-.183-.106l-1.989-3.444a.211.211,0,0,1,0-.211l1.989-3.443a.213.213,0,0,1,.183-.105h0a.212.212,0,0,1,.183.105l1.994,3.443a.21.21,0,0,1,0,.211l-1.994,3.444A.212.212,0,0,1,511.145,210.929Zm-1.746-3.655,1.746,3.022,1.75-3.022-1.75-3.022Z",
    transform: "translate(-508.945 -203.62)",
    fill: "#25292b"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1136",
    "data-name": "Group 1136",
    transform: "translate(0 4.926)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1135",
    "data-name": "Group 1135"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1134",
    "data-name": "Group 1134"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_995",
    "data-name": "Path 995",
    d: "M495.505,203.591a1.2,1.2,0,1,1,1.2-1.2A1.2,1.2,0,0,1,495.505,203.591Zm0-1.981a.779.779,0,1,0,.779.779A.78.78,0,0,0,495.505,201.61Z",
    transform: "translate(-494.304 -201.188)",
    fill: "#25292b"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1139",
    "data-name": "Group 1139",
    transform: "translate(6.502 2.793)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1138",
    "data-name": "Group 1138"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1137",
    "data-name": "Group 1137"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_996",
    "data-name": "Path 996",
    d: "M508.516,198.968a1.049,1.049,0,1,1,1.05-1.049A1.05,1.05,0,0,1,508.516,198.968Zm0-1.676a.628.628,0,1,0,.628.628A.628.628,0,0,0,508.516,197.292Z",
    transform: "translate(-507.467 -196.87)",
    fill: "#25292b"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1142",
    "data-name": "Group 1142",
    transform: "translate(12.758 7.294)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1141",
    "data-name": "Group 1141"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1140",
    "data-name": "Group 1140"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_997",
    "data-name": "Path 997",
    d: "M520.908,207.536a.777.777,0,1,1,.777-.776A.777.777,0,0,1,520.908,207.536Zm0-1.132a.355.355,0,1,0,.356.355A.355.355,0,0,0,520.908,206.4Z",
    transform: "translate(-520.132 -205.983)",
    fill: "#25292b"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1145",
    "data-name": "Group 1145",
    transform: "translate(12.313 0.144)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1144",
    "data-name": "Group 1144"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1143",
    "data-name": "Group 1143"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_998",
    "data-name": "Path 998",
    d: "M520.692,196.255h0a.211.211,0,0,1-.183-.105l-1.249-2.162a.209.209,0,0,1,0-.211l1.249-2.162a.211.211,0,0,1,.183-.106h0a.21.21,0,0,1,.182.105l1.252,2.162a.211.211,0,0,1,0,.212l-1.252,2.162A.211.211,0,0,1,520.692,196.255Zm-1.006-2.373,1.006,1.741,1.009-1.741-1.009-1.742Z",
    transform: "translate(-519.231 -191.508)",
    fill: "#25292b"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1148",
    "data-name": "Group 1148",
    transform: "translate(3.735)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1147",
    "data-name": "Group 1147"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1146",
    "data-name": "Group 1146"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_999",
    "data-name": "Path 999",
    d: "M502.643,192.769a.777.777,0,1,1,.777-.777A.778.778,0,0,1,502.643,192.769Zm0-1.132a.355.355,0,1,0,.355.355A.355.355,0,0,0,502.643,191.637Z",
    transform: "translate(-501.866 -191.216)",
    fill: "#25292b"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1860",
    "data-name": "Group 1860",
    transform: "translate(3417.572 1058.214)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1859",
    "data-name": "Group 1859",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1803",
    "data-name": "Group 1803",
    transform: "translate(0.001 7.771)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_25",
    "data-name": "Ellipse 25",
    cx: 49.426,
    cy: 49.426,
    rx: 49.426,
    ry: 49.426,
    fill: "#dfdedc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1805",
    "data-name": "Group 1805",
    transform: "translate(14.45 34.473)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1804",
    "data-name": "Group 1804"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1328",
    "data-name": "Path 1328",
    d: "M212.917,122.454l-2.8,29.6,3.164,24.9s-15.67,7.717-33.255,7.717-21.28-7.718-21.28-7.718l1.017-19.5H157.9a9.171,9.171,0,0,1-8.269-5.209l-9.075-18.969,12.931-3.413.063-9.115a11.836,11.836,0,0,1,6.9-10.678l10.275-4.717a2.928,2.928,0,0,1,.3-.717c3.418-5.8,12.044-7.489,18.32-6.808,5.079.551,9.393,3.579,10.916,8.08l6.163,2.66A12.145,12.145,0,0,1,212.917,122.454Z",
    transform: "translate(-140.552 -97.685)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1822",
    "data-name": "Group 1822",
    transform: "translate(38.493 2.4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1807",
    "data-name": "Group 1807",
    transform: "translate(3.756 13.592)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1806",
    "data-name": "Group 1806"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1329",
    "data-name": "Path 1329",
    d: "M203.307,72.578c-1,2.525-2.837,3.945-5.216,3.31l1.352,10.357-12.06,5.612L182.766,86.8l.214-4.2-1.791-1.652A13.415,13.415,0,0,1,176.9,70.15l.617-8.853a.4.4,0,0,0,.064.021,13.084,13.084,0,0,0,4.8.278,16.228,16.228,0,0,0,5.388-1.327,2.248,2.248,0,0,0,.6,1.4,3.832,3.832,0,0,0,2.508,1.014,7.282,7.282,0,0,0,3.762-.732q.867,2.455,1.9,4.853l0,.041.013-.011A5.053,5.053,0,0,1,199.7,65.6a4.528,4.528,0,0,1,1.762.319C203.967,66.913,204.38,69.871,203.307,72.578Z",
    transform: "translate(-176.87 -60.268)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1809",
    "data-name": "Group 1809",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1808",
    "data-name": "Group 1808"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1330",
    "data-name": "Path 1330",
    d: "M211.339,48.61l-.418,3.066a5.053,5.053,0,0,0-3.157,1.234c0-.008-.006-.021-.01-.029q-1.031-2.393-1.9-4.853a7.282,7.282,0,0,1-3.762.732,3.832,3.832,0,0,1-2.508-1.014,2.248,2.248,0,0,1-.6-1.4A16.228,16.228,0,0,1,193.6,47.67a13.083,13.083,0,0,1-4.8-.278.4.4,0,0,1-.064-.021,6.366,6.366,0,0,1-3.769-2.727,4.29,4.29,0,0,1,.045-4.571,3.7,3.7,0,0,1,4.619-1.05,4.639,4.639,0,0,1-.351-3.968,3.657,3.657,0,0,1,3.142-2.3,4.293,4.293,0,0,1,3.39,1.793,10.977,10.977,0,0,1,1.664,3.6,2.965,2.965,0,0,1,2.8-1.777,3.352,3.352,0,0,1,2.808,1.846,3.885,3.885,0,0,1-.03,3.4l2.9.251A5.961,5.961,0,0,1,211.339,48.61Z",
    transform: "translate(-184.331 -32.751)",
    fill: "#25292b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1811",
    "data-name": "Group 1811",
    transform: "translate(5.041 20.329)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1810",
    "data-name": "Group 1810",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_26",
    "data-name": "Ellipse 26",
    cx: 1.324,
    cy: 1.465,
    rx: 1.324,
    ry: 1.465,
    transform: "translate(2.642 3.107) rotate(-176.011)",
    fill: "#25292b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1813",
    "data-name": "Group 1813",
    transform: "translate(13.072 20.889)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1812",
    "data-name": "Group 1812",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_27",
    "data-name": "Ellipse 27",
    cx: 1.324,
    cy: 1.465,
    rx: 1.324,
    ry: 1.465,
    transform: "translate(2.642 3.107) rotate(-176.011)",
    fill: "#25292b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1815",
    "data-name": "Group 1815",
    transform: "translate(4.618 18.313)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1814",
    "data-name": "Group 1814",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1331",
    "data-name": "Path 1331",
    d: "M226.1,70.057a3.14,3.14,0,0,0-2.988.338.406.406,0,0,0,.431.689,2.7,2.7,0,0,1,.264-.17c.045-.025.09-.048.136-.071l.016-.007.073-.03a2.669,2.669,0,0,1,.3-.1c.05-.014.1-.025.153-.037l.025,0,.085-.012a2.774,2.774,0,0,1,.314-.022q.079,0,.157,0l.079,0h.009a2.857,2.857,0,0,1,.309.055c.051.012.1.026.152.041l.075.024.013,0,.014.005a.417.417,0,0,0,.551-.164A.412.412,0,0,0,226.1,70.057Z",
    transform: "translate(-222.915 -69.827)",
    fill: "#25292b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1817",
    "data-name": "Group 1817",
    transform: "translate(13.385 18.859)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1816",
    "data-name": "Group 1816",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1332",
    "data-name": "Path 1332",
    d: "M205.33,71.546a.418.418,0,0,0,.523.239l.015,0,.013,0,.078-.013c.052-.008.1-.015.156-.02a2.882,2.882,0,0,1,.314-.012h.009l.079.006c.052,0,.1.011.156.019a2.727,2.727,0,0,1,.308.065l.082.024.024.008c.049.018.1.037.147.057a2.7,2.7,0,0,1,.282.138l.068.04.014.009c.042.029.084.058.125.089a2.687,2.687,0,0,1,.238.205.406.406,0,1,0,.522-.623,3.139,3.139,0,0,0-2.913-.749A.411.411,0,0,0,205.33,71.546Z",
    transform: "translate(-205.311 -70.931)",
    fill: "#25292b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1818",
    "data-name": "Group 1818",
    transform: "translate(6.956 20.979)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1333",
    "data-name": "Path 1333",
    d: "M216.044,82.1h.013l4.106-.243a.224.224,0,0,0,.21-.237.228.228,0,0,0-.237-.21l-3.782.223,1.908-6.118a.224.224,0,1,0-.427-.134l-2,6.428a.224.224,0,0,0,.213.291Z",
    transform: "translate(-215.82 -75.224)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1819",
    "data-name": "Group 1819",
    transform: "translate(25.583 20.199)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1334",
    "data-name": "Path 1334",
    d: "M180.106,81.529a2.656,2.656,0,0,0,2.15-4.229,1.943,1.943,0,0,0-1.237-.811,1.414,1.414,0,0,0-.924.168,4.428,4.428,0,0,1,.255-1.17,2.269,2.269,0,0,1,1.063-1.258,1.049,1.049,0,0,1,.844-.082,1.7,1.7,0,0,1,.741.924.224.224,0,1,0,.4-.193,2.074,2.074,0,0,0-.976-1.146,1.5,1.5,0,0,0-1.21.1,2.716,2.716,0,0,0-1.284,1.5,5.8,5.8,0,0,0-.32,1.892.224.224,0,0,0,.421.113.89.89,0,0,1,.916-.4,1.526,1.526,0,0,1,.946.635,2.208,2.208,0,0,1-1.933,3.51.221.221,0,0,0-.239.207.224.224,0,0,0,.208.239C179.989,81.526,180.048,81.529,180.106,81.529Z",
    transform: "translate(-179.611 -73.645)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1820",
    "data-name": "Group 1820",
    transform: "translate(9.48 34.758)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1335",
    "data-name": "Path 1335",
    d: "M207.251,105.7a5.038,5.038,0,0,0,2.205-.568,12.979,12.979,0,0,0,2.318-1.612.224.224,0,1,0-.283-.347,12.636,12.636,0,0,1-2.236,1.559,4.233,4.233,0,0,1-2.55.474A5.626,5.626,0,0,1,204.336,104a.224.224,0,0,0-.269.359,6.166,6.166,0,0,0,2.562,1.29A3.668,3.668,0,0,0,207.251,105.7Z",
    transform: "translate(-203.978 -103.12)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1821",
    "data-name": "Group 1821",
    transform: "translate(10.711 26.578)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1336",
    "data-name": "Path 1336",
    d: "M210.09,90.125h.019a3.864,3.864,0,0,0,3.494-3.311.224.224,0,0,0-.444-.062,3.415,3.415,0,0,1-3.089,2.927.224.224,0,0,0,.019.447Z",
    transform: "translate(-209.867 -86.558)",
    fill: "#25292b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1823",
    "data-name": "Group 1823",
    transform: "translate(9.168 50)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1337",
    "data-name": "Path 1337",
    d: "M259.925,132.373l6.552,18.1a2.432,2.432,0,0,0,2.29,1.6h7.7a2.433,2.433,0,0,0,2.29-3.26l-6.558-18.1a2.431,2.431,0,0,0-2.284-1.6h-7.7A2.427,2.427,0,0,0,259.925,132.373Z",
    transform: "translate(-259.777 -129.119)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1836",
    "data-name": "Group 1836",
    transform: "translate(10.576 63.583)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_10",
    "data-name": "Union 10",
    d: "M-11932.238-1079.656a1.53,1.53,0,0,1-.749-1.045,1.585,1.585,0,0,1,.565-1.465,1.7,1.7,0,0,1-.46-.225,1.618,1.618,0,0,1-.674-1.057,1.65,1.65,0,0,1,.76-1.685,1.661,1.661,0,0,1-.652-.271,1.629,1.629,0,0,1-.677-1.06,1.647,1.647,0,0,1,.8-1.708,1.428,1.428,0,0,1-.187-.11,1.375,1.375,0,0,1-.572-.9,1.392,1.392,0,0,1,1.132-1.611l4.888-.985a1.4,1.4,0,0,1,1.04.234,1.372,1.372,0,0,1,.572.9,1.39,1.39,0,0,1-.354,1.19,1.621,1.621,0,0,1,.7.28,1.626,1.626,0,0,1,.677,1.057,1.642,1.642,0,0,1-.765,1.685,1.666,1.666,0,0,1,.657.274,1.626,1.626,0,0,1,.677,1.057,1.649,1.649,0,0,1-.575,1.547,1.922,1.922,0,0,1,.351.163,1.527,1.527,0,0,1,.749,1.042,1.791,1.791,0,0,1-1.584,1.947l-4.925.988a2.163,2.163,0,0,1-.375.033A2,2,0,0,1-11932.238-1079.656Z",
    transform: "translate(11934.148 1091.797)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1832",
    "data-name": "Group 1832",
    transform: "translate(6.179 9.225)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1342",
    "data-name": "Path 1342",
    d: "M275.5,178.058a.252.252,0,0,0,.046,0l2.128-.444a2.021,2.021,0,0,0,1.465-2.119.224.224,0,1,0-.444.057,1.6,1.6,0,0,1-1.136,1.629l-2.1.437a.224.224,0,0,0,.045.444Z",
    transform: "translate(-275.276 -175.295)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1833",
    "data-name": "Group 1833",
    transform: "translate(1.509 8.323)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1343",
    "data-name": "Path 1343",
    d: "M283.764,175a.219.219,0,0,0,.058-.008l4.019-1.081a.224.224,0,0,0-.117-.433l-4.019,1.081a.224.224,0,0,0,.058.441Z",
    transform: "translate(-283.54 -173.47)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1834",
    "data-name": "Group 1834",
    transform: "translate(1.091 5.625)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1344",
    "data-name": "Path 1344",
    d: "M285.4,169.3a.257.257,0,0,0,.051-.005l3.628-.841a.224.224,0,0,0-.1-.437l-3.629.841a.224.224,0,0,0,.05.442Z",
    transform: "translate(-285.177 -168.007)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1835",
    "data-name": "Group 1835",
    transform: "translate(0.417 2.634)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1345",
    "data-name": "Path 1345",
    d: "M288.3,163.056a.22.22,0,0,0,.05-.006l2.871-.657a.224.224,0,1,0-.1-.437l-2.871.657a.224.224,0,0,0,.049.442Z",
    transform: "translate(-288.075 -161.951)",
    fill: "#25292b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1844",
    "data-name": "Group 1844",
    transform: "translate(16.066 54.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1837",
    "data-name": "Group 1837",
    transform: "translate(0 9.536)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1346",
    "data-name": "Path 1346",
    d: "M255.179,167.386l-.535-1.642a9.315,9.315,0,0,0-5.885-5.954l-7.746-2.61a3.313,3.313,0,0,0-4.138,1.917l-8.178-2.5a1.679,1.679,0,0,0-2.089,1.114,1.7,1.7,0,0,0-.068.613,1.673,1.673,0,0,0,1.182,1.475l.077.019a1.669,1.669,0,0,0-.957,1.056,1.706,1.706,0,0,0-.068.614,1.671,1.671,0,0,0,1.181,1.475l.61.187a1.626,1.626,0,0,0-.77.96,1.711,1.711,0,0,0-.069.608,1.674,1.674,0,0,0,1.182,1.481l7.033,4.414a19,19,0,0,0,3.7,1.8l11.04,3.968Z",
    transform: "translate(-226.536 -156.528)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1838",
    "data-name": "Group 1838",
    transform: "translate(49.293 29.591)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1347",
    "data-name": "Path 1347",
    d: "M180.872,198.894a.224.224,0,0,0,.088-.43l-3.1-1.317a.224.224,0,1,0-.175.412l3.1,1.317A.229.229,0,0,0,180.872,198.894Z",
    transform: "translate(-177.551 -197.129)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1839",
    "data-name": "Group 1839",
    transform: "translate(10.114 11.881)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1348",
    "data-name": "Path 1348",
    d: "M255.715,164.39a.224.224,0,0,0,.075-.435l-7.465-2.666a.224.224,0,1,0-.151.421l7.466,2.666A.221.221,0,0,0,255.715,164.39Z",
    transform: "translate(-248.026 -161.275)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1840",
    "data-name": "Group 1840",
    transform: "translate(0.962 12.587)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1349",
    "data-name": "Path 1349",
    d: "M270.523,166.713a.224.224,0,0,0,.068-.437l-11.1-3.562a.224.224,0,1,0-.137.426l11.1,3.562A.224.224,0,0,0,270.523,166.713Z",
    transform: "translate(-259.2 -162.704)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1841",
    "data-name": "Group 1841",
    transform: "translate(1.805 15.938)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1350",
    "data-name": "Path 1350",
    d: "M271.128,173.113a.224.224,0,0,0,.076-.435l-8.842-3.176a.224.224,0,1,0-.152.421l8.842,3.177A.224.224,0,0,0,271.128,173.113Z",
    transform: "translate(-262.061 -169.489)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1842",
    "data-name": "Group 1842",
    transform: "translate(2.149 18.986)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1351",
    "data-name": "Path 1351",
    d: "M264.708,183.651a.224.224,0,0,0,.049-.443c-.048-.011-4.558-1.073-12.215-6.067l4.2,1.877a.224.224,0,0,0,.183-.409l-6.556-2.93a.224.224,0,0,0-.219.388c9.03,6.292,14.454,7.565,14.508,7.577A.24.24,0,0,0,264.708,183.651Z",
    transform: "translate(-250.055 -175.661)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1843",
    "data-name": "Group 1843",
    transform: "translate(22.835)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1352",
    "data-name": "Path 1352",
    d: "M174.847,185.065a11.5,11.5,0,0,0,4.974-1.142,11.383,11.383,0,0,0,6.372-8.39l3.857-21.9a.224.224,0,0,0-.442-.078l-3.857,21.9a11.064,11.064,0,0,1-16.245,7.767l-26.019-14.366,5.393-10.946,20.677,9.332a.224.224,0,0,0,.316-.195l1.247-29.591a.224.224,0,0,0-.214-.233.233.233,0,0,0-.233.214L169.44,166.7l-20.572-9.285a.223.223,0,0,0-.293.105l-5.584,11.332a.224.224,0,0,0,.093.295l26.206,14.469A11.469,11.469,0,0,0,174.847,185.065Z",
    transform: "translate(-142.968 -137.222)",
    fill: "#25292b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1845",
    "data-name": "Group 1845",
    transform: "translate(34.665 56.367)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1353",
    "data-name": "Path 1353",
    d: "M246.188,151.775a.224.224,0,0,0,.224-.224v-9.316a.224.224,0,1,0-.448,0v9.316A.224.224,0,0,0,246.188,151.775Z",
    transform: "translate(-245.964 -142.011)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1846",
    "data-name": "Group 1846",
    transform: "translate(44.069 42.546)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1354",
    "data-name": "Path 1354",
    d: "M220.069,119.707a.224.224,0,0,0,.135-.4l-6.911-5.23a.224.224,0,1,0-.27.357l6.911,5.23A.223.223,0,0,0,220.069,119.707Z",
    transform: "translate(-212.934 -114.029)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1847",
    "data-name": "Group 1847",
    transform: "translate(53.957 42.484)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1355",
    "data-name": "Path 1355",
    d: "M169.924,120.2a.215.215,0,0,0,.068-.011l18.378-5.852a.224.224,0,1,0-.136-.427l-18.377,5.852a.224.224,0,0,0,.068.438Z",
    transform: "translate(-169.701 -113.903)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1848",
    "data-name": "Group 1848",
    transform: "translate(48.512 49.683)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1356",
    "data-name": "Path 1356",
    d: "M212,143.144h0a.223.223,0,0,0,.22-.227,32.433,32.433,0,0,1,3.016-14.12.224.224,0,0,0-.406-.189,32.88,32.88,0,0,0-3.057,14.316A.223.223,0,0,0,212,143.144Z",
    transform: "translate(-211.776 -128.478)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1849",
    "data-name": "Group 1849",
    transform: "translate(52.947 50.632)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1357",
    "data-name": "Path 1357",
    d: "M208.189,141.623a.224.224,0,0,0,.222-.193,31.579,31.579,0,0,0-.375-10.852.224.224,0,0,0-.439.092,31.121,31.121,0,0,1,.37,10.7.224.224,0,0,0,.191.253Z",
    transform: "translate(-207.592 -130.4)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1850",
    "data-name": "Group 1850",
    transform: "translate(33.437 81.769)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1358",
    "data-name": "Path 1358",
    d: "M248.25,206.135a.224.224,0,0,0,.224-.22l.209-12.249a.223.223,0,0,0-.22-.227h0a.224.224,0,0,0-.224.22l-.209,12.248a.224.224,0,0,0,.22.228Z",
    transform: "translate(-248.026 -193.438)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1858",
    "data-name": "Group 1858",
    transform: "translate(12.085 19.985)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1856",
    "data-name": "Group 1856",
    transform: "translate(2.254 8.335)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1851",
    "data-name": "Group 1851",
    transform: "translate(1.926 0.666)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1359",
    "data-name": "Path 1359",
    d: "M265.334,86.577v4.967l-9.151,8.5h-.036L247,91.544V86.577Z",
    transform: "translate(-246.996 -86.577)",
    fill: "#d294ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1852",
    "data-name": "Group 1852",
    transform: "translate(0 4.97)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1360",
    "data-name": "Path 1360",
    d: "M259.364,104.234a.322.322,0,0,0,.188-.06l9.151-8.5a.224.224,0,0,0-.153-.388H250.212a.224.224,0,0,0-.152.388l9.151,8.5A.224.224,0,0,0,259.364,104.234Zm8.616-8.5-8.6,7.984-8.6-7.984Z",
    transform: "translate(-249.988 -95.289)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1853",
    "data-name": "Group 1853",
    transform: "translate(0 0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1361",
    "data-name": "Path 1361",
    d: "M250.212,90.648h18.338a.224.224,0,0,0,.224-.224V85.456a.224.224,0,0,0-.224-.224H250.212a.224.224,0,0,0-.224.224v4.967A.224.224,0,0,0,250.212,90.648Zm18.114-.448h-17.89V85.68h17.89Z",
    transform: "translate(-249.988 -85.232)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1854",
    "data-name": "Group 1854",
    transform: "translate(0 0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1362",
    "data-name": "Path 1362",
    d: "M259.4,99.144a.225.225,0,0,0,.2-.129l3.947-8.459,5.156-4.938a.224.224,0,0,0-.31-.324l-5.186,4.968a.228.228,0,0,0-.048.067l-3.754,8.047-3.5-8.041a.226.226,0,0,0-.055-.077l-5.494-4.968a.224.224,0,0,0-.3.332l5.457,4.935,3.674,8.453a.224.224,0,0,0,.2.134Z",
    transform: "translate(-249.988 -85.232)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1855",
    "data-name": "Group 1855",
    transform: "translate(5.493)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1363",
    "data-name": "Path 1363",
    d: "M260.712,90.645a.224.224,0,0,0,.18-.091l3.5-4.734,3.8,4.741a.224.224,0,0,0,.35-.28l-3.983-4.968a.189.189,0,0,0-.179-.084.225.225,0,0,0-.176.091l-3.675,4.968a.223.223,0,0,0,.047.313A.219.219,0,0,0,260.712,90.645Z",
    transform: "translate(-260.488 -85.228)",
    fill: "#25292b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1857",
    "data-name": "Group 1857"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1364",
    "data-name": "Path 1364",
    d: "M248.547,97.33a.225.225,0,0,0,.165-.073l3.257-3.55a12.751,12.751,0,1,0-4.161-1.349l.516,4.772a.224.224,0,0,0,.153.189A.226.226,0,0,0,248.547,97.33Zm3.337-4.085a.223.223,0,0,0-.165.073l-3,3.272-.476-4.4a.223.223,0,0,0-.12-.175,12.279,12.279,0,1,1,3.8,1.232Z",
    transform: "translate(-241.013 -68.354)",
    fill: "#25292b"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1908",
    "data-name": "Group 1908",
    transform: "translate(3243.742 1105.218)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1907",
    "data-name": "Group 1907",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1861",
    "data-name": "Group 1861",
    transform: "translate(-0.001 0.001)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_28",
    "data-name": "Ellipse 28",
    cx: 49.426,
    cy: 49.426,
    r: 49.426,
    fill: "#dfdedc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1862",
    "data-name": "Group 1862",
    transform: "translate(54.124 61.935)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1366",
    "data-name": "Path 1366",
    d: "M147.85,394.068l-8.183,17.112a8.267,8.267,0,0,1-7.456,4.7h-1.687L129.418,389.2Z",
    transform: "translate(-129.418 -389.203)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1864",
    "data-name": "Group 1864",
    transform: "translate(10.352 37.025)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1863",
    "data-name": "Group 1863"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1367",
    "data-name": "Path 1367",
    d: "M93.371,399.067c.508,1.908.863,3.516,1.078,4.526q-.821.568-1.642,1.084a38.061,38.061,0,0,1-11.112,4.735,38.454,38.454,0,0,1-4.656.858c-9.657,1.208-17.975-1.219-23.748-3.482-1.58-.615-2.929-1.219-3.99-1.733-.277-.135-.53-.259-.768-.378-.435-.22-.807-.418-1.1-.576.034-.169.062-.338.1-.508.311-1.6.632-3.115.965-4.526a82.314,82.314,0,0,1,2.331-8.11,52.122,52.122,0,0,1,2.28-5.61,24.314,24.314,0,0,1,2.167-3.753l-.1-4.9-.119-5.61-.022-1.213H40.8v-9.944a17.814,17.814,0,0,1,.2-2.7,19.181,19.181,0,0,1,10.028-14.262,18.319,18.319,0,0,1,2.59-1.134l8.714-3.059,13.911,1.546,6.941,1.829a13.6,13.6,0,0,1,9.882,10.695l.8,4.385.988,5.429H91.006l-.023.181-.914,8.245-.621,5.61-.965,8.657-.09.835c.005.006.011.017.017.023a34.994,34.994,0,0,1,2.308,4.752A67.346,67.346,0,0,1,93.371,399.067Z",
    transform: "translate(-40.801 -338.771)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1881",
    "data-name": "Group 1881",
    transform: "translate(15.105 2.305)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1865",
    "data-name": "Group 1865",
    transform: "translate(14.759 1.602)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1368",
    "data-name": "Path 1368",
    d: "M111.394,285.086a15.066,15.066,0,0,1-4.533,3.465,13.718,13.718,0,0,1-9.263,10.7,13.118,13.118,0,0,1-5.815.415,13.308,13.308,0,0,1-10.309-18.786,14.693,14.693,0,0,1,4.436-5.458,17.358,17.358,0,0,1,4.274-2.443,15.873,15.873,0,0,1,9.13-.953,11.628,11.628,0,0,1,7.5,5.1,10.244,10.244,0,0,0,2.235,3.176,17.032,17.032,0,0,0,1.935,1.017,2.44,2.44,0,0,1,1.351,1.623A2.828,2.828,0,0,1,111.394,285.086Z",
    transform: "translate(-80.304 -271.724)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1866",
    "data-name": "Group 1866"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1369",
    "data-name": "Path 1369",
    d: "M75.921,302.155a5.118,5.118,0,0,1-4.978,2.518,4.188,4.188,0,0,1-3.535-4.095,11.071,11.071,0,0,1-6.185,2.876,6.269,6.269,0,0,1-5.925-2.836,5.99,5.99,0,0,1-.531-4.25,9.438,9.438,0,0,1,2-3.852,8.2,8.2,0,0,1,2.65-16.153,4.907,4.907,0,0,1,.5-6.255,6.059,6.059,0,0,1,6.364-1.219,8,8,0,0,1,4.5,4.886,14.693,14.693,0,0,0-4.436,5.458A13.308,13.308,0,0,0,76.66,298.02,6.344,6.344,0,0,1,75.921,302.155Z",
    transform: "translate(-50.424 -268.48)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1868",
    "data-name": "Group 1868",
    transform: "translate(14.21 9.866)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1867",
    "data-name": "Group 1867"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1370",
    "data-name": "Path 1370",
    d: "M106.015,294.989l-.308,5.953a13.254,13.254,0,0,1-5.506,10.1,15.174,15.174,0,0,1-4.257,2.143l-.394.124.8,3.22h0A6.465,6.465,0,0,1,85.867,318.3l-4.111-4.22,2.433-10.028c-2.418.339-4.055-1.279-4.733-3.879-.732-2.792.028-5.649,2.608-6.327a4.551,4.551,0,0,1,1.771-.1,5.01,5.01,0,0,1,2.958,1.592.011.011,0,0,0,.01.01v-.036h.025c.437-.007,6.962-.187,11.418-4.36a12.585,12.585,0,0,0,2.052-2.493,11.22,11.22,0,0,1,4.554,3.831A8.2,8.2,0,0,1,106.015,294.989Z",
    transform: "translate(-79.192 -288.454)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1870",
    "data-name": "Group 1870",
    transform: "translate(37.182 21.181)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1869",
    "data-name": "Group 1869",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_29",
    "data-name": "Ellipse 29",
    cx: 1.451,
    cy: 1.312,
    rx: 1.451,
    ry: 1.312,
    transform: "matrix(0.233, -0.973, 0.973, 0.233, 0, 2.822)",
    fill: "#25292b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1872",
    "data-name": "Group 1872",
    transform: "translate(29.428 19.325)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1871",
    "data-name": "Group 1871",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_30",
    "data-name": "Ellipse 30",
    cx: 1.451,
    cy: 1.312,
    rx: 1.451,
    ry: 1.312,
    transform: "matrix(0.233, -0.973, 0.973, 0.233, 0, 2.822)",
    fill: "#25292b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1874",
    "data-name": "Group 1874",
    transform: "translate(38.205 19.338)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1873",
    "data-name": "Group 1873"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1371",
    "data-name": "Path 1371",
    d: "M128.093,307.638a3.108,3.108,0,0,1,2.724,1.207.4.4,0,0,1-.611.523,2.728,2.728,0,0,0-.2-.24c-.035-.037-.071-.073-.108-.108l-.012-.011-.06-.049a2.7,2.7,0,0,0-.253-.182c-.043-.028-.088-.054-.134-.079l-.022-.012-.077-.037a2.863,2.863,0,0,0-.29-.114c-.049-.016-.1-.031-.149-.044l-.076-.019h-.009a2.946,2.946,0,0,0-.308-.04c-.052,0-.1-.005-.156-.005h-.106a.413.413,0,0,1-.472-.319A.407.407,0,0,1,128.093,307.638Z",
    transform: "translate(-127.771 -307.63)",
    fill: "#25292b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1876",
    "data-name": "Group 1876",
    transform: "translate(29.657 17.531)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1875",
    "data-name": "Group 1875"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1372",
    "data-name": "Path 1372",
    d: "M113.761,305a.414.414,0,0,1-.565.071l-.013-.008-.012-.006-.069-.036c-.046-.023-.093-.045-.141-.065a2.786,2.786,0,0,0-.293-.1l-.007,0h0l-.076-.018c-.05-.011-.1-.02-.153-.028a2.824,2.824,0,0,0-.31-.03l-.085,0h-.025c-.052,0-.1.005-.156.01a2.7,2.7,0,0,0-.308.047l-.076.017-.017,0c-.048.014-.1.03-.145.047a2.657,2.657,0,0,0-.286.124.4.4,0,1,1-.308-.743,3.108,3.108,0,0,1,2.975.157A.407.407,0,0,1,113.761,305Z",
    transform: "translate(-110.465 -303.973)",
    fill: "#25292b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1877",
    "data-name": "Group 1877",
    transform: "translate(15.779 16.232)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1373",
    "data-name": "Path 1373",
    d: "M85.034,309.346h-.012a2.633,2.633,0,0,1-1.781-4.434,1.926,1.926,0,0,1,1.315-.65,1.433,1.433,0,0,1,.887.274,4.373,4.373,0,0,0-.111-1.176A2.247,2.247,0,0,0,84.437,302a1.044,1.044,0,0,0-.818-.182c-.351.095-.6.442-.837.819a.224.224,0,0,1-.378-.241,2.054,2.054,0,0,1,1.1-1.011,1.483,1.483,0,0,1,1.18.239,2.691,2.691,0,0,1,1.084,1.629,5.731,5.731,0,0,1,.088,1.9.224.224,0,0,1-.192.2.227.227,0,0,1-.24-.141.884.884,0,0,0-.851-.5,1.51,1.51,0,0,0-1,.509,2.185,2.185,0,0,0,1.478,3.68.224.224,0,0,1-.011.448Z",
    transform: "translate(-82.369 -301.343)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1878",
    "data-name": "Group 1878",
    transform: "translate(26.001 31.848)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1374",
    "data-name": "Path 1374",
    d: "M107.759,336.051a4.73,4.73,0,0,1-2.547-.85,12.855,12.855,0,0,1-2.086-1.863.224.224,0,0,1,.323-.311,12.507,12.507,0,0,0,2.011,1.8,4.2,4.2,0,0,0,2.449.771,5.713,5.713,0,0,0,2.474-.9.224.224,0,0,1,.223.389,6.108,6.108,0,0,1-2.675.962C107.874,336.05,107.816,336.051,107.759,336.051Z",
    transform: "translate(-103.064 -332.958)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1879",
    "data-name": "Group 1879",
    transform: "translate(30.265 26.295)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1375",
    "data-name": "Path 1375",
    d: "M113.956,324.5h-.021a2.466,2.466,0,0,1-2.236-2.566.224.224,0,0,1,.448.02,2.018,2.018,0,0,0,1.83,2.1.224.224,0,0,1-.021.447Z",
    transform: "translate(-111.697 -321.716)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1880",
    "data-name": "Group 1880",
    transform: "translate(32.711 20.847)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1376",
    "data-name": "Path 1376",
    d: "M119.6,317.258a.219.219,0,0,1-.091-.019l-2.733-1.224a.224.224,0,0,1,.183-.409l2.419,1.084.034-5.781a.224.224,0,0,1,.224-.222h0a.223.223,0,0,1,.222.225l-.036,6.124a.224.224,0,0,1-.224.222Z",
    transform: "translate(-116.648 -310.686)",
    fill: "#25292b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1887",
    "data-name": "Group 1887",
    transform: "translate(12.301 49.427)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1882",
    "data-name": "Group 1882"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1377",
    "data-name": "Path 1377",
    d: "M89.384,373.3a1.83,1.83,0,0,1-.143.9,1.8,1.8,0,0,1-.712.792,1.743,1.743,0,0,1,.286.781,1.774,1.774,0,0,1-1.213,1.858l.039.015a1.776,1.776,0,0,1,1.031,1.431,1.765,1.765,0,0,1-2.538,1.762l-1.141-.507c-.42,3.54-4.646,5.979-4.646,5.979l-16.1,17.112a9.99,9.99,0,0,1-17.352-5.408l-2.146-15.567,15.861-.9.313,7.429,13.372-9.706,4.113-8.454a7.434,7.434,0,0,1,3.37-2.775l10.085-4.174.349,3.38-6.278,3.3-.033.223,2.455,1.1A1.765,1.765,0,0,1,89.384,373.3Z",
    transform: "translate(-44.746 -363.879)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1883",
    "data-name": "Group 1883",
    transform: "translate(39.384 9.089)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1378",
    "data-name": "Path 1378",
    d: "M128.878,384.535a.228.228,0,0,1-.089-.018l-4.173-1.807a.224.224,0,0,1,.178-.411l4.174,1.807a.224.224,0,0,1-.089.429Z",
    transform: "translate(-124.48 -382.281)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1884",
    "data-name": "Group 1884",
    transform: "translate(38.715 11.781)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1379",
    "data-name": "Path 1379",
    d: "M127.3,389.949a.23.23,0,0,1-.091-.019l-3.954-1.772a.224.224,0,0,1,.183-.409l3.953,1.772a.224.224,0,0,1-.092.428Z",
    transform: "translate(-123.127 -387.73)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1885",
    "data-name": "Group 1885",
    transform: "translate(39.943 15.459)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1380",
    "data-name": "Path 1380",
    d: "M125.917,396.4a.224.224,0,0,1-.222-.2l-.082-.778a.224.224,0,0,1,.2-.246.229.229,0,0,1,.246.2l.082.778a.224.224,0,0,1-.2.246Z",
    transform: "translate(-125.612 -395.177)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1886",
    "data-name": "Group 1886",
    transform: "translate(10.854 24.885)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1381",
    "data-name": "Path 1381",
    d: "M66.945,417.9a.224.224,0,0,1-.12-.413l5.1-3.2a.224.224,0,1,1,.239.379l-5.1,3.2A.223.223,0,0,1,66.945,417.9Z",
    transform: "translate(-66.721 -414.259)",
    fill: "#25292b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1888",
    "data-name": "Group 1888",
    transform: "translate(47.105 46.377)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1382",
    "data-name": "Path 1382",
    d: "M147.261,360.668l-9.921,26.721a2.191,2.191,0,0,1-2.056,1.432H117.4a2.2,2.2,0,0,1-2.056-2.963l9.921-26.721a2.191,2.191,0,0,1,2.056-1.432h17.88A2.2,2.2,0,0,1,147.261,360.668Z",
    transform: "translate(-115.209 -357.705)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1901",
    "data-name": "Group 1901",
    transform: "translate(66.957 60.957)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1890",
    "data-name": "Group 1890",
    transform: "translate(2.128)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1889",
    "data-name": "Group 1889"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1383",
    "data-name": "Path 1383",
    d: "M159.728,388.262a1.26,1.26,0,0,1,1.456-1.02l4.409.887a1.261,1.261,0,0,1,1.02,1.456,1.261,1.261,0,0,1-1.455,1.019l-4.409-.887A1.26,1.26,0,0,1,159.728,388.262Z",
    transform: "translate(-159.709 -387.223)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1892",
    "data-name": "Group 1892",
    transform: "translate(1.201 2.097)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1891",
    "data-name": "Group 1891"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1384",
    "data-name": "Path 1384",
    d: "M157.854,392.69a1.485,1.485,0,0,1,1.715-1.2l4.93.978a1.479,1.479,0,1,1-.512,2.914l-4.931-.979A1.484,1.484,0,0,1,157.854,392.69Z",
    transform: "translate(-157.832 -391.467)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1894",
    "data-name": "Group 1894",
    transform: "translate(0.689 4.814)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1893",
    "data-name": "Group 1893"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1385",
    "data-name": "Path 1385",
    d: "M156.817,398.195a1.485,1.485,0,0,1,1.715-1.2l4.931.978a1.486,1.486,0,0,1,1.2,1.715,1.466,1.466,0,0,1-.609.953,1.483,1.483,0,0,1-1.106.247l-4.931-.979A1.484,1.484,0,0,1,156.817,398.195Z",
    transform: "translate(-156.795 -396.969)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1896",
    "data-name": "Group 1896",
    transform: "translate(0.217 7.332)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1895",
    "data-name": "Group 1895"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1386",
    "data-name": "Path 1386",
    d: "M155.86,403.256a1.378,1.378,0,0,1,.676-.941,1.857,1.857,0,0,1,1.266-.219l4.44.892a1.614,1.614,0,0,1,1.429,1.753,1.385,1.385,0,0,1-.676.944,1.844,1.844,0,0,1-1.265.219l-4.44-.892A1.614,1.614,0,0,1,155.86,403.256Z",
    transform: "translate(-155.841 -402.066)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1897",
    "data-name": "Group 1897",
    transform: "translate(0 8.299)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1387",
    "data-name": "Path 1387",
    d: "M158.719,406.558a.293.293,0,0,1-.046,0l-1.919-.4a1.845,1.845,0,0,1-1.338-1.935.229.229,0,0,1,.25-.194.224.224,0,0,1,.194.251,1.423,1.423,0,0,0,1.01,1.446l1.9.394a.224.224,0,0,1-.046.443Z",
    transform: "translate(-155.401 -404.024)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1898",
    "data-name": "Group 1898",
    transform: "translate(1.112 7.181)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1388",
    "data-name": "Path 1388",
    d: "M164.07,403.488a.243.243,0,0,1-.045,0l-6.195-1.28a.224.224,0,0,1-.174-.265.227.227,0,0,1,.264-.174l6.2,1.279a.224.224,0,0,1-.045.444Z",
    transform: "translate(-157.651 -401.762)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1899",
    "data-name": "Group 1899",
    transform: "translate(1.904 4.59)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1389",
    "data-name": "Path 1389",
    d: "M165.259,398.183a.218.218,0,0,1-.046,0l-5.78-1.219a.224.224,0,1,1,.093-.438l5.779,1.219a.224.224,0,0,1-.046.443Z",
    transform: "translate(-159.255 -396.516)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1900",
    "data-name": "Group 1900",
    transform: "translate(2.413 2.017)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1390",
    "data-name": "Path 1390",
    d: "M166.388,392.683l-.035,0-5.879-.93a.224.224,0,0,1-.186-.256.229.229,0,0,1,.256-.186l5.878.929a.224.224,0,0,1-.035.445Z",
    transform: "translate(-160.285 -391.307)",
    fill: "#25292b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1902",
    "data-name": "Group 1902",
    transform: "translate(11.46 60.064)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1391",
    "data-name": "Path 1391",
    d: "M43.268,393.695a.224.224,0,0,1-.013-.448L61.4,392.13v-6.492a.224.224,0,0,1,.448,0v6.7a.224.224,0,0,1-.21.223l-18.358,1.13Z",
    transform: "translate(-43.044 -385.414)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1906",
    "data-name": "Group 1906",
    transform: "translate(59.419 9.722)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1903",
    "data-name": "Group 1903",
    transform: "translate(2.333 5.92)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1392",
    "data-name": "Path 1392",
    d: "M152.4,324.456a.212.212,0,0,1-.07-.011.224.224,0,0,1-.153-.189l-.516-4.772a12.729,12.729,0,1,1,4.16,1.349l-3.257,3.55A.224.224,0,0,1,152.4,324.456Zm5.2-28.528a12.289,12.289,0,0,0-5.626,23.214.223.223,0,0,1,.12.175l.476,4.4,3-3.272a.22.22,0,0,1,.2-.07,12.291,12.291,0,1,0,1.831-24.446Z",
    transform: "translate(-144.861 -295.48)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1904",
    "data-name": "Group 1904",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1393",
    "data-name": "Path 1393",
    d: "M153.823,296.248a2.791,2.791,0,0,0,4.784,2.025,2.23,2.23,0,0,1,1.527-.7v5.89h-6.092a2.271,2.271,0,0,0,.694,1.442,2.791,2.791,0,0,1-2.025,4.784,2.827,2.827,0,0,1-2.719-2.786,2.779,2.779,0,0,1,.887-2.047,2.08,2.08,0,0,0,.65-1.393h-5.093v-5.348a2.258,2.258,0,0,0-1.514.694,2.791,2.791,0,0,1-4.783-2.02,2.83,2.83,0,0,1,2.786-2.723,2.791,2.791,0,0,1,2.047.891,2.089,2.089,0,0,0,1.465.645v-5.836h3.776a2.277,2.277,0,0,0-.7-1.487,2.791,2.791,0,0,1,2.025-4.783,2.823,2.823,0,0,1,2.719,2.781,2.79,2.79,0,0,1-.887,2.051,2.078,2.078,0,0,0-.65,1.438h7.413v5.3a2.07,2.07,0,0,1-1.478-.65,2.79,2.79,0,0,0-2.052-.887A2.823,2.823,0,0,0,153.823,296.248Z",
    transform: "translate(-140.138 -283.495)",
    fill: "#b08ff0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1905",
    "data-name": "Group 1905",
    transform: "translate(16.659 18.064)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1394",
    "data-name": "Path 1394",
    d: "M173.866,325.229a2.081,2.081,0,0,1,2.048-2,2.05,2.05,0,0,1,1.5.655,1.535,1.535,0,0,0,1.077.474v-4.29h1.8a1.527,1.527,0,0,1-.478,1.057,2.051,2.051,0,0,0-.652,1.508,2.052,2.052,0,0,0,3.754,1.14,2.054,2.054,0,0,0-.267-2.611,1.674,1.674,0,0,1-.514-1.094h6.427v3.9a1.523,1.523,0,0,1-1.087-.477,2.05,2.05,0,0,0-1.508-.652,2.073,2.073,0,0,0-1.778,1.05,1.989,1.989,0,0,0-.267.948,2.052,2.052,0,0,0,3.516,1.488,1.641,1.641,0,0,1,1.123-.514v4.33h-4.478a1.67,1.67,0,0,0,.51,1.061,2.051,2.051,0,0,1-1.488,3.516,2.078,2.078,0,0,1-2-2.048,2.041,2.041,0,0,1,.652-1.5,1.529,1.529,0,0,0,.477-1.024H178.5V326.2a1.66,1.66,0,0,0-1.113.51,2.051,2.051,0,0,1-3.516-1.485Z",
    transform: "translate(-173.866 -320.066)",
    fill: "#b08ff0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1922",
    "data-name": "Group 1922",
    transform: "translate(221 32.313)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1401",
    "data-name": "Path 1401",
    d: "M72.474,220.654v12.432l8.378-5.971Z",
    transform: "translate(3170.931 921.118)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1917",
    "data-name": "Group 1917",
    transform: "translate(3253.86 1141.771)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1402",
    "data-name": "Path 1402",
    d: "M93.64,220.654v12.432l8.378-5.971Z",
    transform: "translate(-93.64 -220.654)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1918",
    "data-name": "Group 1918",
    transform: "translate(3265.307 1141.771)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1403",
    "data-name": "Path 1403",
    d: "M116.815,220.654v12.432l8.378-5.971Z",
    transform: "translate(-116.815 -220.654)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1921",
    "data-name": "Group 1921",
    transform: "translate(3342.581 1111.525)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1404",
    "data-name": "Path 1404",
    d: "M384.334,157.663v12.432l8.378-5.971Z",
    transform: "translate(-384.334 -157.663)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1919",
    "data-name": "Group 1919",
    transform: "translate(10.455)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1405",
    "data-name": "Path 1405",
    d: "M405.5,157.663v12.432l8.378-5.971Z",
    transform: "translate(-405.5 -157.663)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1920",
    "data-name": "Group 1920",
    transform: "translate(21.902)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1406",
    "data-name": "Path 1406",
    d: "M428.675,157.663v12.432l8.378-5.971Z",
    transform: "translate(-428.675 -157.663)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_3",
    "data-name": "Mask Group 3",
    transform: "translate(-632.044 -4792.74)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3050",
    "data-name": "Group 3050",
    transform: "translate(3897.772 5907.991)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3024",
    "data-name": "Group 3024",
    transform: "translate(94.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3802",
    "data-name": "Path 3802",
    d: "M1079.288,210.068c-1.313,16.322-21.7,9.771-31.4,16.41-6.094,4.316-10.886,11.627-18.925,12.29-7.751.593-13.021-7.161-20.775-6.578-8.418.325-16.453,5.98-24.994,3.705-4.312-1.191-8.457-4.555-9.052-9.22-.578-4.538,2.717-7.89,4.653-11.613,5.489-13.582-19.132-11.341-1.219-33.624,3.215-4.151,2.43-9.257-1.32-12.734-4.853-6.153-4.991-16.021,4.342-17.537,7.041-1.994,12.71-6.753,18.994-10.278,14.041-9.149,34.894-1.881,39.116,14.619,2.006,6.551-1.041,12.412,6.966,16.173,14.805,4.832,11.487,6.083,15.4,19.162C1065.811,198.38,1078.852,199.625,1079.288,210.068Z",
    transform: "translate(-970.938 -136.893)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3803",
    "data-name": "Path 3803",
    d: "M358.887,294.615l-6.1-30.662c-4.429-24.972-39.519-26.676-39.519-26.676l-27.629-.46s-20.441-2.743-33.029,11.464c-13.031,14.7-29.06,32.092-29.06,32.092l12.231,30.781,28.958-23.848a29.673,29.673,0,0,0-3.884,13.917c0,8.159,8.517,11.924,8.517,11.924l2.64,24.751L263.5,377.98l89.958-3.611a89.429,89.429,0,0,0-13.3-37.8l1.7-41.955Z",
    transform: "translate(-151.58 -165.539)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3804",
    "data-name": "Path 3804",
    d: "M280.372,250.53a7.986,7.986,0,0,1,.477,1.959c.29,1.448.63,3.237,1.056,5.366.92,4.736,2.112,10.9,3.407,17.716s2.453,13.219,3.168,17.784c.375,2.283.63,4.139.784,5.417a8.142,8.142,0,0,1,.119,2.01,9.112,9.112,0,0,1-.46-1.959c-.29-1.448-.647-3.236-1.056-5.366-.92-4.735-2.112-10.9-3.407-17.716s-2.453-13.2-3.168-17.784c-.375-2.283-.63-4.122-.784-5.417a10.356,10.356,0,0,1-.136-2.01Z",
    transform: "translate(-111.614 -155.743)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3805",
    "data-name": "Path 3805",
    d: "M317.041,269.9a152,152,0,0,1-16.625.511,156.469,156.469,0,0,1-16.625-.392,154.869,154.869,0,0,1,16.625-.494,159.5,159.5,0,0,1,16.625.375Z",
    transform: "translate(-109.206 -142.428)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3806",
    "data-name": "Path 3806",
    d: "M365.745,297.255c-1.7-14.684-4.139-27.255-4.139-27.255H329.751s3.952,18.738,3.083,23c-.784,3.765-62.5,6.252-78.579,6.507-.971-.715-2.351.494-3.594-.6a13.168,13.168,0,0,1-2.743-3.407,20.63,20.63,0,0,1-2.2-4.974,1.7,1.7,0,0,0-3.049-.7c-.647,1.38.085,5.962,3.134,10.391s-4.957,2.129-7.887,1.346-12.128-2.777-13.065-2.044c-1.4,1.073-.528,2.794,2.419,3.509s11.651,3.407,11.174,5.11-15.331-2.674-15.331-2.674-3.032-1.414-3.645.375c-1.09,3.237,15.041,6.507,16.591,6.814,1.073.2.613,1.925-.528,1.7s-14.752-4.548-15.893-1.26c-.886,2.521,13.253,2.828,15.586,5.315s-10.7-1.346-11.447,1.09c-.273.92,5.11,1.329,12.946,2.436a201.677,201.677,0,0,0,24.1.852c18.073.988,81.986,2.317,95.63,1.346C372.337,322.925,366.358,302.365,365.745,297.255Z",
    transform: "translate(-154.486 -142.048)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3807",
    "data-name": "Path 3807",
    d: "M245.9,282.748a25.55,25.55,0,0,1,1.09-4.122c.375-1.278.835-2.777,1.414-4.429.29-.818.613-1.7.971-2.572.2-.477.46-.886.579-1.278a3.8,3.8,0,0,0,.17-1.329,23.13,23.13,0,0,0-.426-2.828c-.17-.92-.341-1.806-.511-2.674-.273-1.7-.545-3.168-.784-4.565a20.727,20.727,0,0,1-.511-4.242,19.827,19.827,0,0,1,1.124,4.122c.307,1.38.63,2.9.971,4.514l.562,2.691a18.731,18.731,0,0,1,.46,2.964,4.378,4.378,0,0,1-.221,1.618,12.86,12.86,0,0,1-.613,1.346c-.358.852-.7,1.7-1.005,2.521-.562,1.55-1.107,3-1.584,4.327A17.252,17.252,0,0,1,245.9,282.748Z",
    transform: "translate(-135.859 -152.803)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3025",
    "data-name": "Group 3025",
    transform: "translate(169.831 103.082)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3808",
    "data-name": "Path 3808",
    d: "M281,255.4c1.107,17.034,1.7,32.791,2.112,49.876a13.015,13.015,0,0,0,6.4-2.01C290.386,295.976,284.867,273.78,281,255.4Z",
    transform: "translate(-281 -255.4)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3809",
    "data-name": "Path 3809",
    d: "M250.46,304.868l80.18,6.439-3.424-8.977-75.973-1.09Z",
    transform: "translate(-132.651 -120.073)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3810",
    "data-name": "Path 3810",
    d: "M181.3,249.3l26.216,76.586H326.21l-.886-3.935-47.985-1.5-22.11-71.2Z",
    transform: "translate(-181.3 -156.644)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3811",
    "data-name": "Path 3811",
    d: "M215.915,272.3c.784,3.151-.562,6.217-3,6.814s-5.11-1.363-5.843-4.514.562-6.2,3-6.814S215.131,269.165,215.915,272.3Z",
    transform: "translate(-163.313 -143.683)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3040",
    "data-name": "Group 3040",
    transform: "translate(106.846 21.082)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3027",
    "data-name": "Group 3027",
    transform: "translate(0.642 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3026",
    "data-name": "Group 3026"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3812",
    "data-name": "Path 3812",
    d: "M1048.323,197.492c-1.4,5.353-4.769,8.688-9.746,7.988l4.5,18.543.514,2.11-8.468,8.694c-2.659,2.728-4.11,4.939-9.509,4.029s-9.757-2.694-12.087-7.671l.676-2.723.977-3.913-.815-.254a31.141,31.141,0,0,1-8.763-4.41,27.3,27.3,0,0,1-11.347-20.8l-.63-12.26a16.817,16.817,0,0,1,2.393-5.567,23.1,23.1,0,0,1,9.381-7.89,25.8,25.8,0,0,0,4.225,5.133c9.179,8.6,22.619,8.965,23.514,8.977l.052.006v.069a.025.025,0,0,0,.023-.017,10.309,10.309,0,0,1,6.093-3.283,9.408,9.408,0,0,1,3.647.208C1048.264,185.856,1049.831,191.741,1048.323,197.492Z",
    transform: "translate(-993.623 -173.365)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3029",
    "data-name": "Group 3029",
    transform: "translate(1.925 23.302)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3028",
    "data-name": "Group 3028",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_76",
    "data-name": "Ellipse 76",
    cx: 2.701,
    cy: 2.988,
    rx: 2.701,
    ry: 2.988,
    transform: "matrix(0.973, -0.233, 0.233, 0.973, 0, 1.258)",
    fill: "#25292b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3031",
    "data-name": "Group 3031",
    transform: "translate(17.897 19.48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3030",
    "data-name": "Group 3030",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_77",
    "data-name": "Ellipse 77",
    cx: 2.701,
    cy: 2.988,
    rx: 2.701,
    ry: 2.988,
    transform: "matrix(0.973, -0.233, 0.233, 0.973, 0, 1.258)",
    fill: "#25292b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3033",
    "data-name": "Group 3033",
    transform: "translate(0 19.506)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3032",
    "data-name": "Group 3032"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3813",
    "data-name": "Path 3813",
    d: "M998.313,207.128a6.405,6.405,0,0,0-5.61,2.484.829.829,0,0,0,1.26,1.078,5.39,5.39,0,0,1,.41-.493c.072-.076.146-.15.222-.222l.027-.023.123-.1a5.591,5.591,0,0,1,.521-.373c.09-.057.183-.111.276-.164l.045-.025c.052-.026.1-.051.158-.076a5.688,5.688,0,0,1,.6-.234c.1-.034.2-.064.308-.091l.156-.039h0l.015,0a6,6,0,0,1,.635-.081c.107-.007.213-.011.32-.012.054,0,.107,0,.161,0h.027l.031,0a.852.852,0,0,0,.972-.657A.838.838,0,0,0,998.313,207.128Z",
    transform: "translate(-992.513 -207.11)",
    fill: "#25292b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3035",
    "data-name": "Group 3035",
    transform: "translate(17.116 15.786)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3034",
    "data-name": "Group 3034"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3814",
    "data-name": "Path 3814",
    d: "M1022.289,202.793a.852.852,0,0,0,1.164.146l.026-.016.024-.013.142-.074c.1-.048.192-.093.291-.135a5.986,5.986,0,0,1,.6-.215l.014-.005h0l.157-.036q.157-.034.315-.058a5.646,5.646,0,0,1,.639-.062l.175,0,.051,0c.107.005.214.012.32.021a5.463,5.463,0,0,1,.634.1l.156.036.034.009c.1.03.2.062.3.1a5.355,5.355,0,0,1,.589.254.829.829,0,0,0,.636-1.532,6.4,6.4,0,0,0-6.127.324A.838.838,0,0,0,1022.289,202.793Z",
    transform: "translate(-1022.123 -200.675)",
    fill: "#25292b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3036",
    "data-name": "Group 3036",
    transform: "translate(45.57 13.281)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3815",
    "data-name": "Path 3815",
    d: "M1072.945,212.481a.289.289,0,0,1-.014-.577,4.671,4.671,0,0,0,3.16-7.868,3.269,3.269,0,0,0-2.188-1.1,1.939,1.939,0,0,0-1.919,1.145.289.289,0,0,1-.557-.079,11.678,11.678,0,0,1,.176-3.855,5.376,5.376,0,0,1,2.16-3.254,2.876,2.876,0,0,1,2.291-.47,4.093,4.093,0,0,1,2.162,2.009.289.289,0,1,1-.487.31,3.593,3.593,0,0,0-1.825-1.761,2.319,2.319,0,0,0-1.824.4,4.8,4.8,0,0,0-1.914,2.91,9.71,9.71,0,0,0-.22,2.828,2.684,2.684,0,0,1,1.979-.758,3.8,3.8,0,0,1,2.589,1.286,5.25,5.25,0,0,1-3.553,8.841Z",
    transform: "translate(-1071.348 -196.342)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3037",
    "data-name": "Group 3037",
    transform: "translate(16.006 45.447)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3816",
    "data-name": "Path 3816",
    d: "M1026.128,258.012q-.172,0-.347-.009a12.427,12.427,0,0,1-5.431-1.958.289.289,0,1,1,.288-.5,11.628,11.628,0,0,0,5.172,1.883,8.885,8.885,0,0,0,5.149-1.618,25.931,25.931,0,0,0,4.171-3.732.289.289,0,0,1,.417.4,26.377,26.377,0,0,1-4.269,3.813A9.574,9.574,0,0,1,1026.128,258.012Z",
    transform: "translate(-1020.204 -251.988)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3038",
    "data-name": "Group 3038",
    transform: "translate(17.876 34.008)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3817",
    "data-name": "Path 3817",
    d: "M1023.727,237.582a.289.289,0,0,1-.026-.577,4.327,4.327,0,0,0,3.924-4.5.289.289,0,0,1,.276-.3h.013a.288.288,0,0,1,.288.276,4.906,4.906,0,0,1-4.448,5.106Z",
    transform: "translate(-1023.439 -232.199)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3039",
    "data-name": "Group 3039",
    transform: "translate(11.326 22.787)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3818",
    "data-name": "Path 3818",
    d: "M1012.472,225.978a.284.284,0,0,1-.156-.046.289.289,0,0,1-.133-.242l-.076-12.613a.289.289,0,0,1,.287-.291h0a.289.289,0,0,1,.289.287l.073,12.171,5.223-2.341a.289.289,0,0,1,.236.527l-5.628,2.522A.279.279,0,0,1,1012.472,225.978Z",
    transform: "translate(-1012.107 -212.787)",
    fill: "#25292b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3049",
    "data-name": "Group 3049",
    transform: "translate(97.301 27.168)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3042",
    "data-name": "Group 3042",
    transform: "translate(0 4.725)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3041",
    "data-name": "Group 3041"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3819",
    "data-name": "Path 3819",
    d: "M986.381,217.971c-5.724,0-10.38-5.81-10.38-12.951s4.656-12.951,10.38-12.951,10.38,5.81,10.38,12.951S992.1,217.971,986.381,217.971Zm0-24.747c-5.086,0-9.224,5.291-9.224,11.8s4.138,11.8,9.224,11.8,9.224-5.291,9.224-11.8S991.467,193.224,986.381,193.224Z",
    transform: "translate(-976.001 -192.068)",
    fill: "#9e6a99"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3044",
    "data-name": "Group 3044",
    transform: "translate(21.52 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3043",
    "data-name": "Group 3043"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3820",
    "data-name": "Path 3820",
    d: "M1023.611,209.8c-5.724,0-10.38-5.81-10.38-12.951s4.657-12.951,10.38-12.951,10.38,5.81,10.38,12.951S1029.335,209.8,1023.611,209.8Zm0-24.746c-5.086,0-9.224,5.291-9.224,11.8s4.138,11.795,9.224,11.795,9.224-5.291,9.224-11.795S1028.7,185.05,1023.611,185.05Z",
    transform: "translate(-1013.231 -183.894)",
    fill: "#9e6a99"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3046",
    "data-name": "Group 3046",
    transform: "translate(40.781 7.448)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3045",
    "data-name": "Group 3045"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3821",
    "data-name": "Path 3821",
    d: "M1047.13,199.609a.578.578,0,0,1-.114-1.145l8.344-1.673a.578.578,0,1,1,.227,1.134l-8.343,1.673A.553.553,0,0,1,1047.13,199.609Z",
    transform: "translate(-1046.552 -196.779)",
    fill: "#9e6a99"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3048",
    "data-name": "Group 3048",
    transform: "translate(19.533 15.411)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3047",
    "data-name": "Group 3047"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3822",
    "data-name": "Path 3822",
    d: "M1010.37,211.925a.578.578,0,0,1-.061-1.153l1.988-.213a.578.578,0,0,1,.123,1.15l-1.988.213A.558.558,0,0,1,1010.37,211.925Z",
    transform: "translate(-1009.793 -210.556)",
    fill: "#9e6a99"
  })))))), /*#__PURE__*/React.createElement("line", {
    id: "Line_53",
    "data-name": "Line 53",
    x2: 236,
    transform: "translate(3266.5 1283.5)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVl3);
export default __webpack_public_path__ + "static/media/vl3.b1deb72ff02596b09c926f37f184f7e9.svg";
export { ForwardRef as ReactComponent };